//console.log("in 3d-model js");
import * as THREE from "three";
import { OrbitControls } from "https://unpkg.com/three@0.148.0/examples/jsm/controls/OrbitControls.js";
import { GLTFLoader } from "https://unpkg.com/three@0.148.0/examples/jsm/loaders/GLTFLoader.js";
import { EffectComposer } from "https://unpkg.com/three@0.148.0/examples/jsm/postprocessing/EffectComposer.js";
import { RenderPass } from "https://unpkg.com/three@0.148.0/examples/jsm/postprocessing/RenderPass.js";

let scene, renderer, camera, controls;
let composer, renderPass;
const apikey = "QaLQzsUNDDcXVPZei0p3fegHMD7AzhJpFoct"; // Replace with your API key
let Lapel_style,
    Lining,
    Shoulders,
    Chest_Pocket,
    Side_pocket,
    Ticket_pockets,
    Vent,
    buttons,
    model,
    dirLight,
    loadingText,
    container;
let aLight = [];
let sCurruntFabric = null;
let intialmodel = "Single_Breasted_2_5_button";
fetchFabrics();
container = document.getElementById("CanvasFrame");
const width = container.clientWidth;
const height = container.clientHeight;

const bodyElement = document.querySelector("body");
const dataPageValue = bodyElement.getAttribute("data-page");
let jacketdiv;
let trouserdiv;
let waistecoatdiv;
let defaultfabriccode = "";
const DEFAULT_FABRIC_TEXTURE_URL ="https://grand-le-mar-media-2.s3.ap-south-1.amazonaws.com/default/Poly_Wool_Fabric_Base_Map1-2.jpg";

const DEFAULT_FABRIC_FALLBACK = {
    repeatable_color_image_url: null,
    repeatable_normal_image_url: null,
    color_r: 128,
    color_g: 128,
    color_b: 128,
    tiling_info: { color_tiling_x: 50, color_tiling_y: 50 },
};

if (dataPageValue == "custom-made-suit") {
    jacketdiv = document.querySelectorAll(
        '.cm-progress-container[data-progress="jacket-design"]'
    )[0];
    trouserdiv = document.querySelectorAll(
        '.cm-progress-container[data-progress="trouser-design"]'
    )[0];
    waistecoatdiv = document.querySelectorAll(
        '.cm-progress-container[data-progress="waistcoat-design"]'
    )[0];
} else {
    jacketdiv = document.getElementsByClassName("cm-preview-block")[0];
    trouserdiv = document.getElementsByClassName("cm-preview-block")[0];
    waistecoatdiv = document.getElementsByClassName("cm-preview-block")[0];
}

// Added by M
/*console.log(jacketdiv);
console.log(trouserdiv);
console.log(waistecoatdiv);*/

//jacket
let Ticket_pocket_value = false;
let sLapelstyle = "concave";
let sLapelwidth = "wide";
let sLapel_button_hole_Position = "right";
let sLapel_buttonhole = "Handmade";
//let sShoulders = "Rounded_Shoulder_5mm";
let sShoulders = "Natural_Shoulder_0mm";
let sAMF = "mm2";
let sChest_Pocket = "Boat_Shape";
let side_pocket_value = "Jetted";
let sLining = "halfline";
let sVent = "double";
let sSleeve_button = "kissing_3";
let Cuffed_sleeve_value = false;


// For Trouser
let waistband,
    back_Pockets,
    side_Pockets,
    coin_Pocket,
    pleats,
    hemFinishing,
    fasteting;

let coin_pocket_value = false;
let Hem_finishing_value = "None";
let Pleat = "Standardsinglee";
let pocket_side = "Slanted";
let TAMF_Size = "AMF_2";
let pockets_back = "jetted_Button";
let waistband_value = "Oscar_Peak_Extended";
let waistband_height = 1;
let fasteting_value = "Side_adjusters_";
let sButtons_texture = "3677KO";

// For Waistcoat
let Collar_Styles, Wback_Pockets, WChest_Pocket, WSide_pocket, light;
let pocketSide = "Straight_pocket";
let pocketsBack = "No_pocket";
let collarStyle = "None";
let buttoning = "Double_Breasted_6_button_V";
let wAMF = "AMF_2";
let backStyle = "Lining";
let backColor = "#FFFFFF";
let jacketactive = false;
let trouseractive = false;
let waistcoatactive = false;
let sLiningColor = "#FFFFFF";
let sCurrentButtonName = "3677KO";

let allfabrics;

const init = () => {
    scene = new THREE.Scene();
    // scene.background = new THREE.Color(0x00f4f4f4);
    camera = new THREE.OrthographicCamera(
        width / -470,
        width / 470,
        height / 470,
        height / -470,
        1,
        1000
    );
    camera.position.z = 60;
    camera.updateProjectionMatrix();
    camera.lookAt(0, 0, 0);
    renderer = new THREE.WebGLRenderer({
        alpha: true,
        antialias: true,
        preserveDrawingBuffer: true,
        powerPreference: "high-performance",
    });
    renderer.toneMapping = THREE.CineonToneMapping;
    renderer.shadowMap.enabled = true;
    renderer.gammaInput = true;
    renderer.gammaOutput = true;
    renderer.setPixelRatio(window.devicePixelRatio);
    renderer.setSize(width, height);
    composer = new EffectComposer(renderer);

    renderPass = new RenderPass(scene, camera);
    composer.addPass(renderPass);

    container.appendChild(renderer.domElement);
    // addLights();
    if (
        dataPageValue == "custom-made-trouser" ||
        trouserdiv.classList.contains("isSelected")
    ) {
        loadGLTFmoadl("Trousere");
        trouseractive = true;
        jacketactive = false;
        waistcoatactive = false;
    } else if (
        dataPageValue == "custom-made-waistcoat" ||
        waistecoatdiv.classList.contains("isSelected")) {
        loadGLTFmoadl("Waistcoat");
        waistcoatactive = true;
        jacketactive = false;
        trouseractive = false;
    } else {
        loadGLTFmoadl(intialmodel);
        jacketactive = true;
        waistcoatactive = false;
        trouseractive = false;
    }

    const addDirectionalLight = (x, y, z, intensity) => {
        // dirLight = new THREE.DirectionalLight(0xd5deff, intensity);
        dirLight = new THREE.DirectionalLight(0xffffff, intensity);
        aLight.push(dirLight);
        dirLight.castShadow = true;
        aLight.target = model;
        camera.add(dirLight);
        scene.add(dirLight);
    };
    addDirectionalLight(0, 0, 0, 4);
    animate();
    orbitControls();
    //loadLodingText();
};

const animate = () => {
    if (controls) controls.update();
    if (dirLight) {
        dirLight.position.set(
            camera.position.x + 20,
            camera.position.y,
            camera.position.z + 10
        );
    }
    requestAnimationFrame(animate);
    composer.render();
};
window.addEventListener("resize", () => {
    camera.left = width / -470;
    camera.right = width / 470;
    camera.top = height / 470;
    camera.bottom = height / -470;
    camera.updateProjectionMatrix();
    renderer.setSize(width, height);
});

// async function loadGLTFmoadl(glbModel) {
//     if (model) {
//         scene.remove(model);

//     }
//     const loader = new GLTFLoader();
//     const staticURL1 = "https://grand-le-mar-media.s3.eu-central-1.amazonaws.com/suit/";
//     const fullURL = `${staticURL1}${glbModel}.glb`
//     //console.log("fullURL ", fullURL)
//     // await loader.loadAsync(`test.glb`).then((glb) => {
//     await loader.loadAsync(fullURL).then((glb) => {
//         model = glb.scene;

//         if (dataPageValue == 'custom-made-waistcoat' || waistecoatdiv.classList.contains("isSelected")) {
//             model.scale.set(0.6, 0.6, 0.6);
//         }
//         else if (dataPageValue == 'custom-made-trouser' || trouserdiv.classList.contains("isSelected")) {
//           model.scale.set(0.22, 0.22, 0.22);
//         }
//         else {
//           model.scale.set(0.01, 0.01, 0.01);
//         }
//         scene.add(model);
//         model.children.forEach((child) => {
//             child.castShadow = true;
//             child.receiveShadow = true;
//         });

//         console.log(model.children);
//         console.log(dataPageValue == 'custom-made-trouser')
//         if (dataPageValue == 'custom-made-trouser' || trouserdiv.classList.contains("isSelected") ) {
//             waistband = model.children[0].children.filter((child) => child.name.substring(0, 4) === ("Waistband").substring(0, 4))[0];
//             coin_Pocket = model.children[0].children.filter((child) => child.name.substring(0, 4) === ("Coin_pocket").substring(0, 4))[0];
//             fasteting = model.children[0].children.filter((child) => child.name.substring(0, 4) === ("Fasteting").substring(0, 4))[0];
//             pleats = model.children[0].children.filter((child) => child.name.substring(0, 4) === ("PLeats").substring(0, 4))[0];
//             hemFinishing = model.children[0].children.filter((child) => child.name.substring(0, 4) === ("HemFinishing").substring(0, 4))[0];
//             side_Pockets = model.children[0].children.filter((child) => child.name.substring(0, 4) === ("Sidepockets").substring(0, 4))[0];
//             back_Pockets = model.children[0].children.filter((child) => child.name.substring(0, 4) === ("Backpocket").substring(0, 4))[0];

//             update_Hem_finishing(Hem_finishing_value);
//             update_Coin_Pocket(coin_pocket_value)
//             update_Pleats(Pleat);
//             update_side_Pockets(pocket_side, TAMF_Size);
//             update_Back_Pockets(pockets_back);

//             update_Waistband(waistband_value, waistband_height);
//             update_Fasteting(fasteting_value, waistband_value, waistband_height);
//             if(loadingText){
//               loadingText.remove();
//             }
//             if(document.body.classList.contains("line-loading-3d-preview")){
//               document.body.classList.remove("line-loading-3d-preview");
//             }
//             updateMaterialFabricTrouser(sCurruntFabric);

//         }
//         else if (dataPageValue == 'custom-made-waistcoat' || waistecoatdiv.classList.contains("isSelected") ) {
//           Collar_Styles = model.children[0].children.filter((child) => child.name.substring(0, 4) === ("buttonning").substring(0, 4))[0];
//           Wback_Pockets = model.children[0].children.filter((child) => child.name.substring(0, 4) === ("back").substring(0, 4))[0];
//           WChest_Pocket = model.children[0].children.filter((child) => child.name.substring(0, 4) === ("Chest_pocket").substring(0, 4))[0];
//           WSide_pocket = model.children[0].children.filter((child) => child.name.substring(0, 4) === ("Side_pocket").substring(0, 4))[0];

//           updateSidePockets(pocketSide);
//           updateChestPockets(pocketsBack);
//           updateCollarStyles(collarStyle);
//           updateBackColor(backColor)
//           if(loadingText){
//             loadingText.remove();
//           }
//           if(document.body.classList.contains("line-loading-3d-preview")){
//               document.body.classList.remove("line-loading-3d-preview");
//             }
//           updateMaterialFabricWaistcoat(sCurruntFabric)
//         }
//         else {
//             Lapel_style = model.children.filter((child) => child.name.substring(0, 4).toUpperCase() === ("Lapel_style").substring(0, 4).toUpperCase())[0];
//             Lining = model.children.filter((child) => child.name.substring(0, 4) === ("Lining").substring(0, 4))[0];
//             Shoulders = model.children.filter((child) => child.name.substring(0, 4) === ("Shoulders").substring(0, 4))[0];
//             Chest_Pocket = model.children.filter((child) => child.name.substring(0, 4) === ("Chest_Pocket").substring(0, 4))[0];
//             Side_pocket = model.children.filter((child) => child.name.substring(0, 4) === ("Side_pocket").substring(0, 4))[0];
//             Ticket_pockets = model.children.filter((child) => child.name.substring(0, 4) === ("Ticket_pockets").substring(0, 4))[0];
//             buttons = model.children.filter((child) => child.name.substring(0, 4) === "buttons".substring(0, 4))[0];

//             update_Lapel_width(sLapelstyle, sLapelwidth, sLapel_buttonhole, sAMF, sLapel_button_hole_Position);
//             update_Chest_Pocket(sChest_Pocket);
//             update_Side_Pocket(side_pocket_value);
//             update_Ticket_pockets(side_pocket_value);
//             update_Lining(sLining);
//             update_Sleeve_Button(sSleeve_button, sChest_Pocket, side_pocket_value);
//             update_Shoulders(sShoulders);

//             update_Vent(sVent, sAMF, sShoulders);
//           update_Cuffed_sleeve(Cuffed_sleeve_value)
//             Shoulders.children.filter((child) => child.name === "spalla_camicia_2mm")[0].material.depthWrite = true;
//             Shoulders.children.filter((child) => child.name === "spalla_camicia_2mm")[0].material.trnsprant = false;
//           console.log(sCurruntFabric)
//             sCurruntFabric && updateMaterialFabric(sCurruntFabric);
//             //console.log("test")
//             if(loadingText){
//               loadingText.remove();
//             }
//             if(document.body.classList.contains("line-loading-3d-preview")){
//               document.body.classList.remove("line-loading-3d-preview");
//             }
//         }
//         // document.body.style.pointerEvents = "fill";
//         // //console.log("Model loaded successfully");

//     });
//   if(document.body.classList.contains("line-loading-3d-preview")){
//     document.body.classList.remove("line-loading-3d-preview");
//   }
// }

// new code

async function loadGLTFmoadl(glbModel) {
    console.log("glbModel",glbModel)
    if (model) {
        scene.remove(model);
    }
    const loader = new GLTFLoader();
    const staticURL1 = "https://grand-le-mar-media-2.s3.ap-south-1.amazonaws.com/suit/";
    const fullURL = `${staticURL1}${glbModel}.glb`;
    //console.log("fullURL ", fullURL);
    await loader.loadAsync(fullURL).then(async (glb) => {
        model = glb.scene;
        model.visible = false;

        console.log("model ::",model)

        if (
            dataPageValue == "custom-made-waistcoat" ||
            waistecoatdiv.classList.contains("isSelected")
        ) {
            model.scale.set(0.671, 0.671, 0.671);
            model.position.y -= 0.165;
        } else if (
            dataPageValue == "custom-made-trouser" ||
            trouserdiv.classList.contains("isSelected")
        ) {
            model.scale.set(0.3, 0.3, 0.3);
            model.position.y += 0.15;
        } else {
            model.scale.set(0.0125, 0.0125, 0.0125);
            //console.log(model);
        }
        scene.add(model);
        model.children.forEach((child) => {
            child.castShadow = true;
            child.receiveShadow = true;
        });

        //console.log(model.children);
        //console.log(dataPageValue == "custom-made-trouser");
        if (dataPageValue == "custom-made-trouser" || trouserdiv.classList.contains("isSelected")) {
            waistband = model.children[0].children.filter(
                (child) => child.name.substring(0, 4) === "Waistband".substring(0, 4)
            )[0];
            coin_Pocket = model.children[0].children.filter(
                (child) => child.name.substring(0, 4) === "Coin_pocket".substring(0, 4)
            )[0];
            fasteting = model.children[0].children.filter(
                (child) => child.name.substring(0, 4) === "Fasteting".substring(0, 4)
            )[0];
            pleats = model.children[0].children.filter(
                (child) => child.name.substring(0, 4) === "PLeats".substring(0, 4)
            )[0];
            hemFinishing = model.children[0].children.filter(
                (child) => child.name.substring(0, 4) === "HemFinishing".substring(0, 4)
            )[0];
            side_Pockets = model.children[0].children.filter(
                (child) => child.name.substring(0, 4) === "Sidepockets".substring(0, 4)
            )[0];
            back_Pockets = model.children[0].children.filter(
                (child) => child.name.substring(0, 4) === "Backpocket".substring(0, 4)
            )[0];

            update_Hem_finishing(Hem_finishing_value);
            update_Coin_Pocket(coin_pocket_value);
            update_Pleats(Pleat);
            update_side_Pockets(pocket_side, TAMF_Size);
            update_Back_Pockets(pockets_back);
            updateButtonImage(coin_Pocket.children[0].children[0].material);

            update_Waistband(waistband_value, waistband_height);
            update_Fasteting(fasteting_value, waistband_value, waistband_height);
            if (loadingText) {
                loadingText.remove();
            }
            if (document.body.classList.contains("line-loading-3d-preview")) {
                document.body.classList.remove("line-loading-3d-preview");
            }
            await updateMaterialFabricTrouser(sCurruntFabric ?? DEFAULT_FABRIC_FALLBACK);
        } else if (dataPageValue == "custom-made-waistcoat" || waistecoatdiv.classList.contains("isSelected")) {
            Collar_Styles = model.children[0].children.filter(
                (child) => child.name.substring(0, 4) === "buttonning".substring(0, 4)
            )[0];
            Wback_Pockets = model.children[0].children.filter(
                (child) => child.name.substring(0, 4) === "back".substring(0, 4)
            )[0];
            WChest_Pocket = model.children[0].children.filter(
                (child) => child.name.substring(0, 4) === "Chest_pocket".substring(0, 4)
            )[0];
            WSide_pocket = model.children[0].children.filter(
                (child) => child.name.substring(0, 4) === "Side_pocket".substring(0, 4)
            )[0];

            updateSidePockets(pocketSide);
            updateChestPockets(pocketsBack);
            updateCollarStyles(collarStyle);
            updateBackColor(backColor);
            //console.log(Collar_Styles.children[0]);
            updateButtonImage(Collar_Styles.children[0].children[1].material);

            if (loadingText) {
                loadingText.remove();
            }
            if (document.body.classList.contains("line-loading-3d-preview")) {
                document.body.classList.remove("line-loading-3d-preview");
            }

            await updateMaterialFabricWaistcoat(sCurruntFabric ?? DEFAULT_FABRIC_FALLBACK);
        } else {
            Lapel_style = model.children.filter((child) => child.name.substring(0, 4).toUpperCase() === "Lapel_style".substring(0, 4).toUpperCase())[0];
            Lining = model.children.filter(
                (child) => child.name.substring(0, 4) === "Lining".substring(0, 4)
            )[0];
            Shoulders = model.children.filter(
                (child) => child.name.substring(0, 4) === "Shoulders".substring(0, 4)
            )[0];
            Chest_Pocket = model.children.filter(
                (child) => child.name.substring(0, 4) === "Chest_Pocket".substring(0, 4)
            )[0];
            Side_pocket = model.children.filter(
                (child) => child.name.substring(0, 4) === "Side_pocket".substring(0, 4)
            )[0];
            Ticket_pockets = model.children.filter(
                (child) =>
                    child.name.substring(0, 4) === "Ticket_pockets".substring(0, 4)
            )[0];
            buttons = model.children.filter(
                (child) => child.name.substring(0, 4) === "buttons".substring(0, 4)
            )[0];


            //console.log("updating lapel width", sLapelstyle)
            update_Lapel_width(sLapelstyle, sLapelwidth, sLapel_buttonhole, sAMF, sLapel_button_hole_Position);
            update_Chest_Pocket(sChest_Pocket);
            update_Side_Pocket(side_pocket_value);
            update_Ticket_pockets(side_pocket_value);
            update_Lining(sLining);
            update_Sleeve_Button(sSleeve_button, sChest_Pocket, side_pocket_value);
            update_Shoulders(sShoulders);
            update_lining_color();
            updateButtonImage(buttons.children[3].children[1].material);

            update_Vent(sVent, sAMF, sShoulders);
            update_Cuffed_sleeve(Cuffed_sleeve_value);
            Shoulders.children.filter(
                (child) => child.name === "spalla_camicia_2mm"
            )[0].material.depthWrite = true;
            Shoulders.children.filter(
                (child) => child.name === "spalla_camicia_2mm"
            )[0].material.trnsprant = false;
            await updateMaterialFabric(sCurruntFabric ?? DEFAULT_FABRIC_FALLBACK);
            //console.log("test");
            if (loadingText) {
                loadingText.remove();
            }
            if (document.body.classList.contains("line-loading-3d-preview")) {
                document.body.classList.remove("line-loading-3d-preview");
            }
        }
    });
    if (document.body.classList.contains("line-loading-3d-preview")) {
        document.body.classList.remove("line-loading-3d-preview");
    }
}

const orbitControls = () => {
    controls = new OrbitControls(camera, renderer.domElement);
    controls.enableDamping = true;
    controls.enablePan = false;
    controls.minPolarAngle = Math.PI / 2;
    controls.maxPolarAngle = Math.PI / 2;
    controls.minZoom = 0.75;
    controls.maxZoom = 1.5;
    controls.enableZoom = false;
};

const update_lining_color = () => {

    console.log("update_lining_color",Lining)

    Lining.children[0].material.map = null;
    Lining.children[0].material.metalnessMap = null;
    Lining.children[0].material.roughnessMap = null;
    Lining.children[0].material.normal = null;
    Lining.children[0].material.color.set(sLiningColor);
    Lining.children[0].material.needsUpdate = true;


    // const textureLoader = new THREE.TextureLoader();
    // const url = `https://grand-le-mar-uploads-2.s3.ap-south-1.amazonaws.com/buttons/jacket/gray-lines.jpg`;

    // textureLoader.load(url, function (texture) {
    //   // Dispose of the old texture to avoid memory leaks
    //   if (Lining.children[0].material.map) {
    //     Lining.children[0].material.map.dispose();
    //   }

    //   // Adjust texture settings
    //   texture.encoding = THREE.sRGBEncoding;
    //   texture.wrapS = THREE.RepeatWrapping;
    //   texture.wrapT = THREE.RepeatWrapping;

    //   // Increase repetition — higher numbers = denser pattern
    //   texture.repeat.set(15, 15); // You can tweak these values

    //   texture.needsUpdate = true;

    //   const material = Lining.children[0].material;
    //   material.map = texture;
    //   material.needsUpdate = true;
    //   material.metalness = 1;
    //   material.roughness = 1;
    // });
};

const updateButtonImage = async (buttonMaterial) => {
    // console.log("sButtons_texture", sButtons_texture);
    const textureLoader = new THREE.TextureLoader();
    const url = `https://grand-le-mar-uploads-2.s3.ap-south-1.amazonaws.com/buttons/jacket/${sButtons_texture}.png`;
    //console.log("button texture update ::",url)

    textureLoader.load(url, function (texture) {
        // Dispose of the old texture to avoid memory leaks
        if (buttonMaterial.map) {
            buttonMaterial.map.dispose();
        }

        // Adjust texture settings
        texture.encoding = THREE.sRGBEncoding;
        texture.needsUpdate = true;

        buttonMaterial.map = texture;
        buttonMaterial.needsUpdate = true;
        buttonMaterial.metalness = 1;
        buttonMaterial.roughness = 1;
    });
};

function loadLodingText() {
    loadingText = document.createElement("div");
    loadingText.innerHTML = "Loading...";

    container.appendChild(loadingText);
    const logo = document.createElement("img");
    logo.src = "https://grandlemar.com/cdn/shop/t/152/assets/logo.svg";
    loadingText.appendChild(logo);
    loadingText.classList.add("loading-text");
}
const addLights = () => {
    let addDirectionalLight;
    if (dataPageValue == "custom-made-waistcoat") {
        addDirectionalLight = (x, y, z, intensity) => {
            dirLight = new THREE.DirectionalLight(0xd5deff, intensity);
            dirLight.position.set(x, y, z);
            aLight.push(dirLight);
            scene.add(dirLight);
        };
    } else {
        addDirectionalLight = (init) => {
            dirLight = new THREE.DirectionalLight(0xffffff, init);
            dirLight.position.set(0, 0, 0);
            dirLight.castShadow = true;
            dirLight.shadow.mapSize.width = 1024;
            dirLight.shadow.mapSize.height = 1024;

            aLight.push(dirLight);
            scene.add(dirLight);
            // gui.add(dirLight, 'intensity').min(1).max(50).step(0.01).name('Light Intensity');
        };
    }

    if (
        dataPageValue == "custom-made-trouser" ||
        trouserdiv.classList.contains("isSelected")
    ) {
        addDirectionalLight(0, 0, 0, 6);
    } else if (
        dataPageValue == "custom-made-waistcoat" ||
        waistecoatdiv.classList.contains("isSelected")
    ) {
        addDirectionalLight(0, 0, 0, 6);

        light = new THREE.DirectionalLight(0xd5deff, 4);
        light.position.set(0, 10, 50);
        scene.add(light);
    } else {
        const pointLight = new THREE.PointLight(0xff0000, 0.5, 100);
        pointLight.position.set(0, 0, 10);
        scene.add(pointLight);

        let hemiLight = new THREE.HemisphereLight(0xffffff, 0xffffff, 1);
        hemiLight.color.setHSL(1, 1, 1);
        hemiLight.groundColor.setHSL(0.095, 0.7, 0.7);
        hemiLight.position.set(-10, 0, 0);
        scene.add(hemiLight);

        // const ambientLight = new THREE.AmbientLight(0x404040, 0.5); // Grayish color, intensity 0.5
        // scene.add(ambientLight); // Add the ambient light to the scene

        const spotLight = new THREE.SpotLight(0x00ff00);
        spotLight.position.set(0, 0, 0);
        spotLight.target.position.set(0, 0, 0);
        scene.add(spotLight);
        scene.add(spotLight.target);

        addDirectionalLight(6);
    }
};
init();

// // For Trouser
// const updateMaterialFabricTrouser = (fabric) => {
//     const textureLoader = new THREE.TextureLoader();
//     getColorIntensityCategory(fabric.color_r, fabric.color_g, fabric.color_b);

//     const updateMaterialTextures = (material) => {
//         const loadTexture = (url, callback) => {
//             textureLoader.load(url, (texture) => {
//                 callback(texture);
//                 material.needsUpdate = true;
//             });
//         };

//         // if (fabric.metalness_hq_image_url || fabric.repeatable_metalness_image_url) {
//         //     loadTexture(fabric.metalness_hq_image_url || fabric.repeatable_metalness_image_url, (texture) => {
//         //         material.metalnessMap = texture;
//         //     });
//         // }
//         // if (fabric.repeatable_roughness_hq_image_url || fabric.repeatable_roughness_image_url) {
//         //     loadTexture(fabric.repeatable_roughness_hq_image_url || fabric.repeatable_roughness_image_url, (texture) => {
//         //         material.roughnessMap = texture;
//         //     });
//         // }
//         // if (fabric.repeatable_displacement_hq_image_url || fabric.repeatable_displacement_image_url) {
//         //     loadTexture(fabric.repeatable_displacement_hq_image_url || fabric.repeatable_displacement_image_url, (texture) => {
//         //         material.displacement = texture;
//         //     });
//         // }
//         if ( fabric.repeatable_normal_image_url) {
//             loadTexture( fabric.repeatable_normal_image_url, (texture) => {
//                 material.normal = texture;
//             });
//         }
//         // if (fabric.repeatable_rma_hq_image_url || fabric.repeatable_rma_image_url) {
//         //     loadTexture(fabric.repeatable_rma_hq_image_url || fabric.repeatable_rma_image_url, (texture) => {
//         //         material.rma = texture;
//         //     });
//         // }
//         // if (fabric.repeatable_specular_hq_image_url || fabric.repeatable_specular_image_url) {
//         //     loadTexture(fabric.repeatable_specular_hq_image_url || fabric.repeatable_specular_image_url, (texture) => {
//         //         material.specular = texture;
//         //     });
//         // }
//         // if (fabric.repeatable_ao_hq_image_url || fabric.repeatable_ao_image_url) {
//         //     loadTexture(fabric.repeatable_ao_hq_image_url || fabric.repeatable_ao_image_url, (texture) => {
//         //         material.ao = texture;
//         //     });
//         // }

//         if (fabric.repeatable_color_image_url) {
//             loadTexture(fabric.repeatable_color_image_url, (texture) => {
//                 texture.encoding = THREE.sRGBEncoding;
//                 texture.wrapS = texture.wrapT = THREE.RepeatWrapping;
//                 texture.repeat.set(fabric.tiling_info.color_tiling_x*0.5, fabric.tiling_info.color_tiling_y*0.5);
//                 material.map = texture;
//             });
//         }

//         material.displacementScale = fabric.displacement_scale || 0;
//         material.metalness = fabric.metalness || 0;
//         material.roughness = fabric.roughness || 1;
//         material.specular_value = fabric.specular_value || 0;
//         material.shininess = fabric.shininess;
//         material.needsUpdate = true;
//     };
//     updateMaterialTextures(pleats.children[0].material);
//     updateMaterialTextures(pleats.children[3].material);
//     updateMaterialTextures(pleats.children[4].material);
//     updateMaterialTextures(side_Pockets.children[0].material);
//     updateMaterialTextures(fasteting.children[0].material);
// };

const loadTextureWithFallback = async (textureLoader, primaryUrl, fallbackUrl) => {
    if (primaryUrl) {
        try {
            return await textureLoader.loadAsync(primaryUrl);
        } catch (error) {
            console.error("Error loading texture:", error);
        }
    }
    if (fallbackUrl) {
        try {
            return await textureLoader.loadAsync(fallbackUrl);
        } catch (error) {
            console.error("Error loading fallback texture:", error);
        }
    }
    return null;
};

const getFabricTiling = (fabric, multiplier = 1) => {
    const tilingX = (fabric?.tiling_info?.color_tiling_x ?? 1) * multiplier;
    const tilingY = (fabric?.tiling_info?.color_tiling_y ?? 1) * multiplier;
    return { tilingX, tilingY };
};


const updateMaterialFabricTrouser = async (fabric) => {
    //console.log("updateMaterialFabricTrouser", fabric);
    const textureLoader = new THREE.TextureLoader();
    getColorIntensityCategory(fabric.color_r, fabric.color_g, fabric.color_b);
    const updateMaterialTextures = async (material) => {
        const [normalTexture, colorTexture] = await Promise.all([
            loadTextureWithFallback(
                textureLoader,
                fabric?.repeatable_normal_image_url,
                null
            ),
            loadTextureWithFallback(
                textureLoader,
                fabric?.repeatable_color_image_url,
                DEFAULT_FABRIC_TEXTURE_URL
            ),
        ]);
        if (normalTexture) {
            material.normal = normalTexture;
        }
        if (colorTexture) {
            colorTexture.encoding = THREE.sRGBEncoding;
            colorTexture.wrapS = colorTexture.wrapT = THREE.RepeatWrapping;
            const { tilingX, tilingY } = getFabricTiling(fabric, 0.5);
            colorTexture.repeat.set(tilingX, tilingY);
            material.map = colorTexture;
        } else {
            material.map = null;
            material.color?.set?.(RGBtoHex(fabric.color_r, fabric.color_g, fabric.color_b));
        }
        material.displacementScale = fabric.displacement_scale || 0;
        material.metalness = fabric.metalness || 0;
        material.roughness = fabric.roughness || 1;
        material.specular_value = fabric.specular_value || 0;
        material.shininess = fabric.shininess;
        material.needsUpdate = true;
    };
    await Promise.all([
        updateMaterialTextures(pleats.children[0].material),
        updateMaterialTextures(pleats.children[3].material),
        updateMaterialTextures(pleats.children[4].material),
        updateMaterialTextures(side_Pockets.children[0].material),
        updateMaterialTextures(fasteting.children[0].material),
    ]);
    model.visible = true;
    const sColorCode = RGBtoHex(fabric.color_r, fabric.color_g, fabric.color_b);
    //console.log(side_Pockets.children[0].children[0].material, sColorCode);

    side_Pockets.children[0].children[0].material.color = "#888888";
};

// // FOR JACKET
// const updateMaterialFabric = (fabric) => {
//     console.log(fabric);
//     const textureLoader = new THREE.TextureLoader();

//     const updateMaterialTextures = (material) => {
//         const loadTexture = (url, callback) => {
//             textureLoader.load(url, (texture) => {
//                 callback(texture);
//                 material.needsUpdate = true;
//             });
//         };

//         // if (fabric.metalness_hq_image_url || fabric.repeatable_metalness_image_url) {
//         //     loadTexture(fabric.metalness_hq_image_url || fabric.repeatable_metalness_image_url, (texture) => {
//         //         material.metalnessMap = texture;
//         //     });
//         // }
//         // if (fabric.repeatable_roughness_hq_image_url || fabric.repeatable_roughness_image_url) {
//         //     loadTexture(fabric.repeatable_roughness_hq_image_url || fabric.repeatable_roughness_image_url, (texture) => {
//         //         material.roughnessMap = texture;
//         //     });
//         // }
//         // if (fabric.repeatable_displacement_hq_image_url || fabric.repeatable_displacement_image_url) {
//         //     loadTexture(fabric.repeatable_displacement_hq_image_url || fabric.repeatable_displacement_image_url, (texture) => {
//         //         material.displacement = texture;
//         //     });
//         // }
//         if (fabric.repeatable_normal_image_url) {
//             loadTexture(fabric.repeatable_normal_image_url, (texture) => {
//                 material.normal = texture;
//             });
//         }
//         // if (fabric.repeatable_rma_hq_image_url || fabric.repeatable_rma_image_url) {
//         //     loadTexture(fabric.repeatable_rma_hq_image_url || fabric.repeatable_rma_image_url, (texture) => {
//         //         material.rma = texture;
//         //     });
//         // }
//         // if (fabric.repeatable_specular_hq_image_url || fabric.repeatable_specular_image_url) {
//         //     loadTexture(fabric.repeatable_specular_hq_image_url || fabric.repeatable_specular_image_url, (texture) => {
//         //         material.specular = texture;
//         //     });
//         // }
//         // if (fabric.repeatable_ao_hq_image_url || fabric.repeatable_ao_image_url) {
//         //     loadTexture(fabric.repeatable_ao_hq_image_url || fabric.repeatable_ao_image_url, (texture) => {
//         //         material.ao = texture;
//         //     });
//         // }

//         if (fabric.repeatable_color_image_url) {
//             loadTexture(fabric.repeatable_color_image_url, (texture) => {
//                 texture.encoding = THREE.sRGBEncoding;
//                 texture.wrapS = texture.wrapT = THREE.RepeatWrapping;
//                 texture.repeat.set(fabric.tiling_info.color_tiling_x, fabric.tiling_info.color_tiling_y);
//                 material.map = texture;
//             });
//         }

//         // material.displacementScale = fabric.displacement_scale || 0;
//         // material.metalness = fabric.metalness || 0;
//         // material.roughness = fabric.roughness || 1;
//         material.metalness = 0;
//         material.roughness = 1;
//         // material.specular_value = fabric.specular_value || 0;
//         // material.shininess = fabric.shininess;
//         material.needsUpdate = true;
//     };
//     console.log(Lapel_style);

//     updateMaterialTextures(Lapel_style.children[0].children[1].material);
//     updateMaterialTextures(Side_pocket.children[4].material);
//     updateMaterialTextures(Shoulders.children[5].material);
//     updateMaterialTextures(Shoulders.children[0].material);

//     // Lapel_style.children[0].children[2].children[0].material.emissive.setRGB(
//     //     fabric.color_r / 255,
//     //     fabric.color_g / 255,
//     //     fabric.color_b / 255
//     // );
//     // Lapel_style.children[0].children[3].children[0].material.needsUpdate = true;
//     getColorIntensityCategory(fabric.color_r, fabric.color_g, fabric.color_b);
// };

// FOR JACKET
const updateMaterialFabric = async (fabric) => {
    const textureLoader = new THREE.TextureLoader();
    const updateMaterialTextures = async (material) => {
        const [normalTexture, colorTexture] = await Promise.all([
            loadTextureWithFallback(
                textureLoader,
                fabric?.repeatable_normal_image_url,
                null
            ),
            loadTextureWithFallback(
                textureLoader,
                fabric?.repeatable_color_image_url,
                DEFAULT_FABRIC_TEXTURE_URL
            ),
        ]);
        if (normalTexture) {
            material.normal = normalTexture;
        }
        if (colorTexture) {
            colorTexture.encoding = THREE.sRGBEncoding;
            colorTexture.wrapS = colorTexture.wrapT = THREE.RepeatWrapping;
            const { tilingX, tilingY } = getFabricTiling(fabric, 1);
            colorTexture.repeat.set(tilingX, tilingY);
            material.map = colorTexture;
        } else {
            material.map = null;
            material.color?.set?.(RGBtoHex(fabric.color_r, fabric.color_g, fabric.color_b));
        }
        material.metalness = 0;
        material.roughness = 1;
        material.needsUpdate = true;
    };
    //console.log(Lapel_style);
    await Promise.all([
        updateMaterialTextures(Lapel_style.children[0].children[1].material),
        updateMaterialTextures(Side_pocket.children[4].material),
        updateMaterialTextures(Shoulders.children[5].material),
        updateMaterialTextures(Shoulders.children[0].material),
    ]);
    getColorIntensityCategory(fabric.color_r, fabric.color_g, fabric.color_b);
    model.visible = true;
};

// For Waistcoat
const updateMaterialFabricWaistcoat = (fabric) => {
    const textureLoader = new THREE.TextureLoader();
    const updateMaterialTextures = (material) => {
        const loadTexture = (url, callback) => {
            textureLoader.load(url, (texture) => {
                callback(texture);
                material.needsUpdate = true;
            });
        };
        if (fabric.repeatable_metalness_image_url) {
            loadTexture(fabric.repeatable_metalness_image_url, (texture) => {
                material.metalnessMap = texture;
            });
        }

        if (fabric.repeatable_roughness_image_url) {
            loadTexture(fabric.repeatable_roughness_image_url, (texture) => {
                material.roughnessMap = texture;
            });
        }
        if (fabric.repeatable_displacement_image_url) {
            loadTexture(fabric.repeatable_displacement_image_url, (texture) => {
                material.displacement = texture;
            });
        }
        if (fabric.repeatable_normal_image_url) {
            loadTexture(fabric.repeatable_normal_image_url, (texture) => {
                material.normal = texture;
            });
        }
        if (fabric.repeatable_rma_image_url) {
            loadTexture(fabric.repeatable_rma_image_url, (texture) => {
                material.rma = texture;
            });
        }
        if (fabric.repeatable_specular_image_url) {
            loadTexture(fabric.repeatable_specular_image_url, (texture) => {
                material.specular = texture;
            });
        }
        if (fabric.repeatable_ao_image_url) {
            loadTexture(fabric.repeatable_ao_image_url, (texture) => {
                material.ao = texture;
            });
        }

        const colorUrl = fabric?.repeatable_color_image_url || DEFAULT_FABRIC_TEXTURE_URL;

        if (colorUrl) {
            
            loadTexture(colorUrl, (texture) => {
                texture.encoding = THREE.sRGBEncoding;
                texture.wrapS = texture.wrapT = THREE.RepeatWrapping;
                const { tilingX, tilingY } = getFabricTiling(fabric, 0.5);
                texture.repeat.set(tilingX, tilingY);
                material.map = texture;
            });
        } else {
            material.map = null;
            material.color?.set?.(RGBtoHex(fabric.color_r, fabric.color_g, fabric.color_b));
        }

        material.displacementScale = fabric.displacement_scale || 0;
        material.metalness = fabric.metalness || 0;
        material.roughness = fabric.roughness || 1;
        material.specular_value = fabric.specular_value || 0;
        material.shininess = fabric.shininess;
        material.needsUpdate = true;
    };
    updateMaterialTextures(Collar_Styles.children[7].children[0].material);

    const sColorCode = RGBtoHex(fabric.color_r, fabric.color_g, fabric.color_b);
    // color bleck
    // Collar_Styles.children[0].children[5].children[0].material.color.set(0x000000);
    // Collar_Styles.children[0].children[5].children[0].material.emissive.set(sColorCode);
    Collar_Styles.children[0].children[5].children[0].material.needsUpdate = true;

    getColorIntensityCategoryWaistcoat(
        fabric.color_r,
        fabric.color_g,
        fabric.color_b
    );
    model.visible = true;
};
// For Waistcot
function getColorIntensityCategoryWaistcoat(color_r, color_g, color_b) {
    const toLinear = (c) =>
        c > 0.04045 ? Math.pow((c + 0.055) / 1.055, 2.4) : c / 12.92;
    // Normalize RGB values
    const rLinear = toLinear(color_r / 255);
    const gLinear = toLinear(color_g / 255);
    const bLinear = toLinear(color_b / 255);

    // Calculate luminance
    const luminance = 0.2126 * rLinear + 0.7152 * gLinear + 0.0722 * bLinear;

    // Determine the intensity category
    let intensity = getIntensity(luminance);
    //console.log(luminance, intensity, color_r, color_g, color_b);

    // Apply intensity to all lights
    // light && (light.intensity = intensity)

    const backFabrics = backStyle === "Lining";
    // if (backFabrics) {
    //     aLight[0].intensity = 1;
    // } else {
    //     aLight[0].intensity = intensity;
    // }
}
const RGBtoHex = (r, g, b) => {
    const colorToHex = (color) => {
        const hexadecimal = color.toString(16);
        return hexadecimal.length == 1 ? "0" + hexadecimal : hexadecimal;
    };
    return "#" + colorToHex(r) + colorToHex(g) + colorToHex(b);
};

function getColorIntensityCategory(color_r, color_g, color_b) {
    // Convert RGB to linear light (gamma correction)
    const toLinear = (c) =>
        c > 0.04045 ? Math.pow((c + 0.055) / 1.055, 2.4) : c / 12.92;

    // Normalize RGB values
    const rLinear = toLinear(color_r / 255);
    const gLinear = toLinear(color_g / 255);
    const bLinear = toLinear(color_b / 255);

    // Calculate luminance
    const luminance = 0.2126 * rLinear + 0.7152 * gLinear + 0.0722 * bLinear;

    // Determine the intensity category
    let intensity = getIntensity(luminance);
    // log

    //  aLight.forEach((light) => {
    //     light.intensity = intensity;
    // });
}

function getIntensity(luminance) {
    switch (true) {
        case luminance < 0.001:
            return 20;
        case luminance < 0.005:
            return 13;
        case luminance < 0.01:
            return 11;
        case luminance < 0.05:
            return 9;
        case luminance < 0.1:
            return 5;
        case luminance < 0.25:
            return 2.5;
        case luminance < 0.3:
            return 2;
        case luminance < 0.4:
            return 2;
        case luminance < 0.5:
            return 1.5;
        case luminance < 0.6:
            return 1.5;
        case luminance < 0.7:
            return 1;
        case luminance < 0.8:
            return 0.8;
        case luminance < 0.9:
            return 0.5;
        default:
            return 0.1;
    }
}

const update_Lapel_width = (Lapel, Lapel_width, Lapel_buttonhole, AMF_Size, hole_Position) => {
    // const Lapel = 'concave';
    // const Lapel_width = 'narrow';
    // const Lapel_buttonhole = 'right';
    // const AMF_Size = 'mm2';
    // const hole_Position = 'Traditional';
    Lapel_style.children.forEach((child) => (child.visible = false));

    /*Lapel_style.children.forEach(stl => {
      console.log('Lapel', stl.name, stl.name.substring(0, 1), Lapel_width.substring(0, 1))
    });
    return;*/
    console.log("Lapel_width",Lapel_width)
    // console.log("Lapel_style.children",Lapel_style.children)
    console.log("Lapel_style.children list",Lapel_style.children
        .filter((child) => child.name === Lapel)[0]
        .children)
    console.log("Lapel_style.children",Lapel_style.children
        .filter((child) => child.name === Lapel)[0]
        .children.filter(
            (child) => child.name.substring(0, 1) === Lapel_width.substring(0, 1)
        ))
    Lapel_style.children.filter((child) => child.name === Lapel)[0].children.filter((child) => (child.visible = false));
    Lapel_style.children.filter(
        (child) => child.name === Lapel
    )[0].visible = true;
    Lapel_style.children
        .filter((child) => child.name === Lapel)[0]
        .children.filter(
            (child) => child.name.substring(0, 1) === Lapel_width.substring(0, 1)
        )[0].visible = true;

    // // Lapel_buttonhole

    Lapel_style.children
        .filter((child) => child.name === Lapel)[0]
        .children.filter(
            (child) => child.name.substring(0, 4) === "Buttonhole".substring(0, 4)
        )[0]
        .children.forEach((child) => (child.visible = false));
    Lapel_style.children
        .filter((child) => child.name === Lapel)[0]
        .children.filter(
            (child) => child.name.substring(0, 4) === "Buttonhole".substring(0, 4)
        )[0].visible = true;



    Lapel_style.children
        .filter((child) => child.name === Lapel)[0]
        .children.filter(
            (child) => child.name.substring(0, 4) === "Buttonhole".substring(0, 4)
        )[0]
        .children.filter(
            (child) => child.name.substring(0, 4) === Lapel_buttonhole.substring(0, 4)
        )[0].visible = true;

    Lapel_style.children
        .filter((child) => child.name === Lapel)[0]
        .children.filter(
            (child) => child.name.substring(0, 4) === "Buttonhole".substring(0, 4)
        )[0]
        .children.filter(
            (child) => child.name.substring(0, 4) === Lapel_buttonhole.substring(0, 4)
        )[0]
        .children.forEach((child) => (child.visible = false));

    // Lapel_button_hole_Position
    // console.log(Lapel_style.children.filter((child) => child.name === Lapel)[0].children.filter((child) => child.name.substring(0, 4) === 'Buttonhole'.substring(0, 4))[0].children.filter((child) => child.name.substring(0, 4) === Lapel_buttonhole.substring(0, 4))[0].children.filter((child) => child.name.substring(0, 3).toUpperCase() === hole_Position.substring(0, 3).toUpperCase())[0]);

    if (hole_Position === "Both") {
        Lapel_style.children
            .filter((child) => child.name === Lapel)[0]
            .children.filter(
                (child) => child.name.substring(0, 4) === "Buttonhole".substring(0, 4)
            )[0]
            .children.filter(
                (child) =>
                    child.name.substring(0, 4) === Lapel_buttonhole.substring(0, 4)
            )[0]
            .children.forEach((child) => (child.visible = true)),
            Lapel_style.children
                .filter((child) => child.name === Lapel)[0]
                .children.filter(
                    (child) => child.name.substring(0, 4) === "Buttonhole".substring(0, 4)
                )[0]
                .children.filter(
                    (child) =>
                        child.name.substring(0, 4) === Lapel_buttonhole.substring(0, 4)
                )[0]
                .children.forEach((child) =>
                    child.children.forEach((child) => (child.visible = false))
                ),
            Lapel_style.children
                .filter((child) => child.name === Lapel)[0]
                .children.filter(
                    (child) => child.name.substring(0, 4) === "Buttonhole".substring(0, 4)
                )[0]
                .children.filter(
                    (child) =>
                        child.name.substring(0, 4) === Lapel_buttonhole.substring(0, 4)
                )[0]
                .children.forEach((child) =>
                    child.children.forEach(
                        (child) =>
                            child.name.substring(0, 1).toUpperCase() ===
                            Lapel_width.substring(0, 1).toUpperCase() &&
                            (child.visible = true)
                    )
                );
    } else {
        hole_Position !== "None" &&
            ((Lapel_style.children
                .filter((child) => child.name === Lapel)[0]
                .children.filter(
                    (child) => child.name.substring(0, 4) === "Buttonhole".substring(0, 4)
                )[0]
                .children.filter(
                    (child) =>
                        child.name.substring(0, 4) === Lapel_buttonhole.substring(0, 4)
                )[0]
                .children.filter(
                    (child) =>
                        child.name.substring(0, 3).toUpperCase() ===
                        hole_Position.substring(0, 3).toUpperCase()
                )[0].visible = true),
                Lapel_style.children
                    .filter((child) => child.name === Lapel)[0]
                    .children.filter(
                        (child) => child.name.substring(0, 4) === "Buttonhole".substring(0, 4)
                    )[0]
                    .children.filter(
                        (child) =>
                            child.name.substring(0, 4) === Lapel_buttonhole.substring(0, 4)
                    )[0]
                    .children.filter(
                        (child) =>
                            child.name.substring(0, 3).toUpperCase() ===
                            hole_Position.substring(0, 3).toUpperCase()
                    )[0]
                    .children.forEach((child) => (child.visible = false)),
                (Lapel_style.children
                    .filter((child) => child.name === Lapel)[0]
                    .children.filter(
                        (child) => child.name.substring(0, 4) === "Buttonhole".substring(0, 4)
                    )[0]
                    .children.filter(
                        (child) =>
                            child.name.substring(0, 4) === Lapel_buttonhole.substring(0, 4)
                    )[0]
                    .children.filter(
                        (child) =>
                            child.name.substring(0, 3).toUpperCase() ===
                            hole_Position.substring(0, 3).toUpperCase()
                    )[0]
                    .children.filter(
                        (child) =>
                            child.name.substring(0, 1).toUpperCase() ===
                            Lapel_width.substring(0, 1).toUpperCase()
                    )[0].visible = true));
    }

    // // AMF
    Lapel_style.children
        .filter((child) => child.name === Lapel)[0]
        .children.filter(
            (child) => child.name.substring(0, 1) === Lapel_width.substring(0, 1)
        )[0]
        .children.forEach((child) => (child.visible = false)),
        // AMF_Size !== 'None' && (
        //     Lapel_style.children.filter((child) => child.name === Lapel)[0].children.filter((child) => child.name.substring(0, 1) === Lapel_width.substring(0, 1))[0].children.filter((child) => child.name.substring(0, 3) === AMF_Size.substring(0, 3))[0].visible = true
        // )
        Lapel_style.children
            .filter((child) => child.name === Lapel)[0]
            .children.filter(
                (child) => child.name.substring(0, 1) === Lapel_width.substring(0, 1)
            )[0]
            .children.forEach(
                (child) => child.name.substring(0, 2) === "b2" && (child.visible = true)
            );
    // console.log(Lapel_style.children.filter((child) => child.name === Lapel)[0].children.filter((child) => child.name.substring(0, 1) === Lapel_width.substring(0, 1))[0]);
};

const update_Shoulders = (Shoulder) => {
    // const Shoulder = document.getElementById("Shoulders").value;
    /*console.log('Shoulder', Shoulder);
    Shoulders.children.forEach(child => {
      console.log(child.name)
    })*/
    Shoulders.children.forEach((child) => (child.visible = false));
    Shoulders.children.filter((child) => child.name === Shoulder)[0].visible = true;
    // Shoulders.children.filter((child) => child.name === 'Unlined001')[0].visible = true;
};

const update_Chest_Pocket = (Chest_Pocket_value) => {
    Chest_Pocket.children.forEach((child) => (child.visible = false));
    if(Chest_Pocket_value !=="None"){
        Chest_Pocket.children.filter(
            (child) => child.name.substring(0, 4) === Chest_Pocket_value.substring(0, 4)
        )[0].visible = true;
    }
};

const update_Side_Pocket = (side_pocket_value) => {
    // const side_pocket_value = 'Flap';
    Side_pocket.children.forEach((child) => (child.visible = false));

    /*Side_pocket.children.forEach(sld => {
      console.log('match - ', side_pocket_value.length - 3, sld.name.substring(0, side_pocket_value.length - 3), side_pocket_value.substring(0, side_pocket_value.length - 3))
      if(sld.name.substring(0, side_pocket_value.length - 3) === side_pocket_value.substring(0, side_pocket_value.length - 3)){
        //console.log("Matched")
      }
    });
    return;*/

    //console.log('side - ', Side_pocket.children.filter((child) => child.name.substring(0, side_pocket_value.length - 3) === side_pocket_value.substring(0, side_pocket_value.length - 3))[0]);

    Side_pocket.children.filter(
        (child) =>
            child.name.substring(0, side_pocket_value.length - 3) ===
            side_pocket_value.substring(0, side_pocket_value.length - 3)
    )[0].visible = true;
    // Side_pocket.children.filter((child) => child.name.substring(0, 4) === side_pocket_value.substring(0, 4))[0].visible = true;
    // document.getElementById("ticket_pocket").checked = false;
    // update_Ticket_pockets();
    // update_Sleeve_Button();
};
const update_Ticket_pockets = (side_pocket_value) => {
    // const side_pocket_value = document.getElementById("side_pocket").value;
    // Ticket_pocket_value = true;
    //console.log(Ticket_pocket_value);
    const filter_value = Ticket_pockets.children.filter(
        (child) =>
            child.name.substring(0, side_pocket_value.length - 3) ===
            side_pocket_value.substring(0, side_pocket_value.length - 3)
    );
    Ticket_pockets.children.forEach((child) => (child.visible = false));
    Ticket_pocket_value &&
        filter_value.length > 0 &&
        (filter_value[0].visible = true);

    // document.getElementById("ticket_pocket").disabled = filter_value.length === 0 ? true : false;
};
const update_Vent = (Vent_value, AMF_Size, Shoulder) => {
    // const Vent_value = document.getElementById("Vent").value;
    // const AMF_Size = document.getElementById("AMF").value;
    // const Shoulder = document.getElementById("Shoulders").value;
    const bIsShouldersvent =
        Shoulders.children.filter((child) => child.name === Shoulder)[0].children
            .length > 0;
    // Vent.children.forEach((child) => child.visible = false);

    Shoulders.children
        .filter((child) => child.name === Shoulder)[0]
        .children.forEach((child) => (child.visible = false));
    Shoulders.children
        .filter((child) => child.name === Shoulder)[0]
        .children.filter(
            (child) => child.name.substring(0, 1) === Vent_value.substring(0, 1)
        )[0].visible = true;
    // Shoulders.children.filter((child) => child.name === Shoulder)[0].children.filter((child) => child.name.substring(0, 3) === Vent_value.substring(0, 3))[0].visible = true;
    // Shoulders.children.filter((child) => child.name === Shoulder)[0].children.filter((child) => child.name.substring(0, 1) === Vent_value.substring(0, 1))[0].children.filter((child) => child.name.substring(0, 3) === 'mm6')[0].visible = AMF_Size.substring(0, 3) === 'mm6'
    // Shoulders.children.filter((child) => child.name === Shoulder)[0].children.filter((child) => child.name.substring(0, 1) === Vent_value.substring(0, 1))[0].children.filter((child) => child.name.substring(0, 3) === 'mm2')[0].visible = AMF_Size.substring(0, 3) === 'mm2'
    // Vent.children.filter((child) => child.name === Vent_value)[0].children.filter((child) => child.name.substring(0, 3) === 'mm6')[0].visible = AMF_Size.substring(0, 3) === 'mm6'
    // Vent.children.filter((child) => child.name === Vent_value)[0].children.filter((child) => child.name.substring(0, 3) === 'mm2')[0].visible = AMF_Size.substring(0, 3) === 'mm2'
};
const update_Lining = (Lining_value) => {
    // const Lining_value = document.getElementById("Lining").value;
    Lining.children.forEach((child) => (child.visible = false));
    Lining.children.filter(
        (child) =>
            child.name.substring(0, 3).toUpperCase() ===
            Lining_value.substring(0, 3).toUpperCase()
    )[0].visible = true;
    Lining.children[2].visible = true;
};
// update_Sleeve_Button

const update_Sleeve_Button = (Sleeve_Button_value, Chest_Pocket, side_pocket) => {
    // const Sleeve_Button_value = document.getElementById("Sleeve_button").value;
    console.log("update sleeve button::",Sleeve_Button_value, Chest_Pocket, side_pocket)
    buttons.children.forEach((child) =>
        child.children.forEach((child) => (child.visible = false))
    );
    //console.log(Sleeve_Button_value);
    //console.log("button",Sleeve_Button_value, buttons.children[1].children.filter((child) => child.name === Sleeve_Button_value));
    //console.log(buttons.children[1].children);
    buttons.children[1].children.filter((child) => child.name === Sleeve_Button_value)[0].visible = true;

    console.log("buttons.children[2]", buttons.children[2].children[0])
    buttons.children[0].children[0].visible =
        Chest_Pocket === "pleat_B" ? true : false;
    buttons.children[2].children[0].visible =
        side_pocket === "Pleat_Patch" ? true : false;
    buttons.children[3].children[0].visible = true;
    buttons.children[1].children.filter(
        (child) => child.name === Sleeve_Button_value
    )[0].children[1].visible = false;
};
const update_Cuffed_sleeve = (Cuffed_sleeve_value) => {
    const AMF_Size = sAMF;
    Shoulders.children.filter(
        (child) => child.name === "Cuffed_sleeve"
    )[0].visible = Cuffed_sleeve_value;

    // Shoulders.children.filter((child) => child.name === 'Cuffed_sleeve')[0].children[1].visible = AMF_Size.substring(0, 3) === 'mm6';
    // Shoulders.children.filter((child) => child.name === 'Cuffed_sleeve')[0].children[0].visible = AMF_Size.substring(0, 3) === 'mm2';
};
// All Functions For Trousers

const update_Hem_finishing = (Hem_finishing_value) => {
    // const Hem_finishing_value = document.getElementById("Hem_finishing").value;
    hemFinishing.children.forEach((child) => (child.visible = false));
    console.log("Hem_finishing_value ::",Hem_finishing_value)
    Hem_finishing_value !== "None" && (hemFinishing.children.filter((child) => child.name === Hem_finishing_value)[0].visible = true);
};
const update_Pleats = (Pleat) => {
    
    pleats.children.forEach((child) => (child.visible = false));
    pleats.children.filter((child) => child.name === Pleat)[0].visible = true;
    pleats.children.filter((child) => child.name === Pleat)[0].material.transparent = true;
    pleats.children.filter((child) => child.name === Pleat)[0].material.depthWrite = true;
};
const update_side_Pockets = (pocket_side, TAMF_Size) => {
    // const pocket_side = document.getElementById("Side_Pocket").value;
    // const TAMF_Size = document.getElementById("AMF").value;
    side_Pockets.children.forEach((child) => (child.visible = false));

    side_Pockets.children.filter(
        (child) => child.name === pocket_side
    )[0].visible = true;

    side_Pockets.children
        .filter((child) => child.name === pocket_side)[0]
        .children.forEach((child) => (child.visible = false)),
        TAMF_Size !== "No_AMF" &&
        (side_Pockets.children
            .filter((child) => child.name === pocket_side)[0]
            .children.filter(
                (child) => child.name.substring(0, 5) === TAMF_Size
            )[0].visible = true);
};
const update_Back_Pockets = (pockets_back) => {
    // const pockets_back = document.getElementById("Back_pockets").value;
    back_Pockets.children.forEach((child) => (child.visible = false));
    back_Pockets.children.filter(
        (child) => child.name === pockets_back
    )[0].visible = true;
};
const update_Coin_Pocket = (coin_pocket_value) => {
    if (coin_pocket_value == true) {
        coin_Pocket.children[0].visible = true;
    } else {
        coin_Pocket.children[0].visible = false;
    }
};

const update_Waistband = (waistband_value, waistband_height) => {
    // const waistband_value = document.getElementById("Waistband").value;
    // const waistband_height = document.getElementById("Waistband_height").value;
    const isOscar = waistband_value.substring(0, 4) === "Oscar".substring(0, 4);

    waistband.children.forEach((child) =>
        child.children.forEach((child) => (child.visible = false))
    );
    waistband.children.filter(
        (child) => child.name === waistband_value
    )[0].visible = true;
    // waistband.children.filter((child) => child.name === waistband_value)[0].children[0].visible = true;
    waistband.children.filter((child) => child.name === waistband_value)[0].children[isOscar ? waistband_height : 0].visible = true;
    waistband.children.filter((child) => child.name === "Gurkha")[0].children[0].children[4].visible = false;
    // update_Fasteting();
};

//Fasteting
const update_Fasteting = (fasteting_value, waistband_value, waistband_height) => {
    //console.log(fasteting_value,waistband_value,waistband_height,fasteting.children);
    // const fasteting_value = document.getElementById("Fasteting");
    // const waistband_value = document.getElementById("Waistband").value;
    // const waistband_height = document.getElementById("Waistband_height").value;
    fasteting.children.forEach((child) => (child.visible = false));
    // document.getElementById("Fasteting").disabled = false;
    // document.getElementById("Waistband_height").disabled = false;
    // fasteting_value.options[1].disabled = false

    if (waistband_value.substring(0, 4) !== "Oscar".substring(0, 4)) {
        if (waistband_value !== "Butterfly") {
            // document.getElementById("Fasteting").disabled = true;
            // document.getElementById("Waistband_height").disabled = true;
            return;
        } else {
            // fasteting_value.options[1].disabled = true
            // document.getElementById("Waistband_height").disabled = true;
        }
    }

    if (fasteting_value === "Belt" && fasteting_value !== "None") {
        fasteting.children[waistband_height].visible = true;
    } else {

        console.log("fasteting.children",fasteting.children)
        console.log("fasteting_value",fasteting_value) // Side_adjusters

        fasteting_value !== "None" &&
            (fasteting.children.filter(
                (child) => child.name === fasteting_value
            )[0].visible = true);
        fasteting_value !== "None" &&
                (fasteting.children.filter(
                  (child) => child.name === fasteting_value
                )[0].position.y = waistband_height / 40)
    }
    fasteting.children[waistband_height].children[0].visible =
        waistband_value.split("_")[2] !== "Extended" && fasteting_value === "Belt";
};

// For Waistcoat

const updateSidePockets = (pocketSide) => {
    // const pocketSide = document.getElementById("Side_Pocket").value;
    WSide_pocket.children.forEach((child) => (child.visible = false));
    WSide_pocket.children.find(
        (child) => child.name === pocketSide
    ).visible = true;
};
const updateChestPockets = (pocketsBack) => {
    // const pocketsBack = document.getElementById("Chest_Pocket").value;
    const isHorseStyle = collarStyle !== "Horse";

    WChest_Pocket.children.forEach((child) => (child.visible = false));
    if (pocketsBack !== "No_pocket" && isHorseStyle) {
        WChest_Pocket.children.find(
            (child) => child.name === pocketsBack
        ).visible = true;
    }
    // document.getElementById("Chest_Pocket").disabled = !isHorseStyle;
};

const updateCollarStyles = (collarStyle) => {
    // const collarStyle = document.getElementById("Collar_Style").value;
    // const amfSize = document.getElementById("AMF").value;

    // const buttoning = document.getElementById("Buttoning").value;
    //console.log(buttoning);
    Collar_Styles.children.forEach((child) => (child.visible = false));
    if (collarStyle === "Horse") {
        let Horsevalue;
        switch (buttoning) {
            case "Single_Breasted_5_V_Shape":
                Horsevalue = "Horse_shoe_SB_5";
                break;
            case "Single_Breasted_4_V_Shape":
                Horsevalue = "Horse_shoe_SB_4";
                break;
            case "Single_Breasted_6_V_Shape":
                Horsevalue = "Horse_shoe_SB_6";
                break;
            case "Double_Breasted_6_button_V":
                Horsevalue = "Horse_shoe_DB_6";
                break;
        }
        Collar_Styles.children.filter(
            (child) => child.name === Horsevalue
        )[0].visible = true;
    } else {
        Collar_Styles.children
            .filter((child) => child.name === buttoning)[0]
            .children.forEach(
                (child) =>
                    (child.name.substring(0, 5) === "Notch" ||
                        child.name.substring(0, 4) === "Peak") &&
                    (child.visible = false)
            );
        Collar_Styles.children.filter(
            (child) => child.name === buttoning
        )[0].visible = true;
        collarStyle !== "None" &&
            (Collar_Styles.children
                .filter((child) => child.name === buttoning)[0]
                .children.filter(
                    (child) => child.name.substring(0, 4) === collarStyle.substring(0, 4)
                )[0].visible = true);

        // AMF Size
        Collar_Styles.children
            .filter((child) => child.name === buttoning)[0]
            .children.forEach(
                (child) =>
                    (child.name.substring(0, 5) === "Notch" ||
                        child.name.substring(0, 4) === "Peak") &&
                    child.children.forEach((child) => (child.visible = false))
            );
        collarStyle !== "None" &&
            Collar_Styles.children
                .filter((child) => child.name === buttoning)[0]
                .children.filter(
                    (child) => child.name.substring(0, 4) === collarStyle.substring(0, 4)
                )[0]
                .children.filter(
                    (child) =>
                        child.name.substring(0, 5) === wAMF && (child.visible = true)
                );
    }
};
const updateBackColor = (backColor) => {
    // const backStyle = document.getElementById("Back_Style").value;
    // const colorFabric = document.getElementById("color-fabric");

    // colorFabric.style.display = backStyle !== 'Fabric' ? "block" : "none";
    const backFabrics = backStyle === "Lining";

    if (backFabrics) {
        model.children[0].children[3].material.metalness = 1;
        model.children[0].children[3].material.roughness = 1;
    }

    model.children[0].children[0].visible = backStyle === "Fabric";
    model.children[0].children[3].visible = backStyle === "Lining";

    model.children[0].children[3].material.color.set(backColor);
    model.children[0].children[3].material.roughness = 2;

    model.children[0].children[3].material.needsUpdate = true;
};

// api
async function fetchFabrics() {
    // const responsestatic = await axios.get('https://mtm.tg3ds.com/api/v1/fabrics/OZyYmEmZ?apikey=null&ticket=5Ce-ieTrXS3iRaLT5VyAbQyYUXL7dtvazqysiAKPNaq_q7nr-zQQT8q5sSNHPQfmBRM0Vjx5');
    // console.log(responsestatic)
    // if (dataPageValue == 'custom-made-trouser' || trouserdiv.classList.contains("isSelected")) {
    //     model && updateMaterialFabricTrouser(responsestatic.data);
    // }
    // else if (dataPageValue == 'custom-made-waistcoat' || waistecoatdiv.classList.contains("isSelected")) {
    //     model && updateMaterialFabricWaistcoat(responsestatic.data)
    //   }
    // else {
    //     model && updateMaterialFabric(responsestatic.data);
    // }

    // sCurruntFabric = responsestatic.data;

    const response = await axios.get(
        "https://grand-le-mar.lc.webdevprojects.cloud/api/v1/fetch/fabrics"
    );
    allfabrics = response.data.data;
    // ShowFabrics(response.data.data);
    console.log("defaultfabriccode",defaultfabriccode);
    const fid = response.data.data?.filter(
        (fabric) => fabric.id === defaultfabriccode
    );
    // sCurruntFabric = fid[0];
    sCurruntFabric = null;

    if (
        dataPageValue == "custom-made-trouser" ||
        trouserdiv.classList.contains("isSelected")
    ) {
        model && updateMaterialFabricTrouser(sCurruntFabric ?? DEFAULT_FABRIC_FALLBACK);
    } else if (
        dataPageValue == "custom-made-waistcoat" ||
        waistecoatdiv.classList.contains("isSelected")
    ) {
        model && updateMaterialFabricWaistcoat(sCurruntFabric ?? DEFAULT_FABRIC_FALLBACK);
    } else {
        model && updateMaterialFabric(sCurruntFabric ?? DEFAULT_FABRIC_FALLBACK);
    }
}

let previousSelectedDiv = null;
let price;
let fprice;
let metperperproduct;
let cmt;
let markupprice;
let finalprice;
if (dataPageValue == "custom-made-jacket") {
    metperperproduct = 2;
    cmt = 1250;
    markupprice = 2000;
} else if (dataPageValue == "custom-made-trouser") {
    metperperproduct = 1.5;
    cmt = 310;
    markupprice = 1000;
} else if (dataPageValue == "custom-made-waistcoat") {
    metperperproduct = 0.9;
    cmt = 470;
    markupprice = 950;
} else if (dataPageValue == "custom-made-suit") {
    metperperproduct = 3.5;
    cmt = 1560;
    markupprice = 3950;
}

function ShowFabrics(fabrics) {
    const container = document.getElementById("fabric-container");
    fabrics.forEach((fabric) => {
        if (fabric.repeatable_color_image_url) {
            const fabricDiv = document.createElement("div");
            fabricDiv.className = "fabric-div";

            fabricDiv.addEventListener("click", function () {
                if (previousSelectedDiv) {
                    previousSelectedDiv.classList.remove("selected");
                }

                if (previousSelectedDiv !== this) {
                    this.classList.add("selected");
                    previousSelectedDiv = this;
                } else {
                    previousSelectedDiv = null;
                }
            });

            // Create an image element
            const img = document.createElement("img");
            img.src = fabric.repeatable_color_image_url;
            img.alt = fabric.id;
            img.className = "fabric-image";

            const idDiv = document.createElement("div");
            idDiv.innerText = fabric.serial_number;
            idDiv.className = "fabric-serial_number";

            const priceDiv = document.createElement("div");
            priceDiv.innerText = fabric.price_per_yard;
            priceDiv.className = "fabric-price";

            fabricDiv.appendChild(img);
            fabricDiv.appendChild(idDiv);
            fabricDiv.appendChild(priceDiv);

            // container.appendChild(fabricDiv);
            // img.addEventListener('click', () => {
            //     console.log(fabric)
            //     sCurruntFabric = fabric;
            //       console.log(model)
            //   fprice = fabric.price_per_yard;
            //   finalprice = ((fprice * metperperproduct) + cmt + markupprice) * 1.25
            //   console.log(fprice)
            //   price = document.getElementsByClassName('price')[0];
            //   console.log(price)
            //   price.innerHTML =  finalprice + " Kr."
            //     if (dataPageValue == 'custom-made-trouser' || trouserdiv.classList.contains("isSelected") || trouseractive) {
            //       console.log(jacketactive,trouseractive,waistcoatactive)
            //         updateMaterialFabricTrouser(fabric);
            //         //console.log("Trouser Updated")
            //       console.log(fabric)

            //     }
            //     else if (dataPageValue == 'custom-made-waistcoat' || waistecoatdiv.classList.contains("isSelected") || waistcoatactive) {
            //       console.log(jacketactive,trouseractive,waistcoatactive)
            //       updateMaterialFabricWaistcoat(fabric)
            //       //console.log("Waistcoat Updated")

            //     }
            //     else {
            //       console.log(jacketactive,trouseractive,waistcoatactive)
            //       updateMaterialFabric(fabric);
            //       //console.log("Jacket Updated")

            //     }

            // });
        }
    });
    if (document.body.classList.contains("line-loading")) {
        document.body.classList.remove("line-loading");
    }
}

//console.log(trouserdiv);
$(document).on("click", ".btn-customize.next_button, .btm_tab .cm-toggle-item", function () {
    //console.log("clicked");
    setTimeout(() => {
        if (trouserdiv.classList.contains("isSelected")) {
            document.body.classList.add("line-loading-3d-preview");
            //console.log("Trouser Loaded");
            //loadLodingText();
            loadGLTFmoadl("Trousere");
            // updateMaterialFabricTrouser(sCurruntFabric);
            trouseractive = true;
            jacketactive = false;
            waistcoatactive = false;

            //console.log(sCurruntFabric);

            // scene.children.forEach(child => {
            //     scene.remove(child);
            //    //console.log("removed all childeren", scene)
            // });
            // scene.add(loadGLTFmoadl('Trousere'));
            // model && updateMaterialFabricTrouser(responsestatic.data);

            //  waistband = model.children[0].children.filter((child) => child.name.substring(0, 4) === ("Waistband").substring(0, 4))[0];
            //   coin_Pocket = model.children[0].children.filter((child) => child.name.substring(0, 4) === ("Coin_pocket").substring(0, 4))[0];
            //   fasteting = model.children[0].children.filter((child) => child.name.substring(0, 4) === ("Fasteting").substring(0, 4))[0];
            //   pleats = model.children[0].children.filter((child) => child.name.substring(0, 4) === ("PLeats").substring(0, 4))[0];
            //   hemFinishing = model.children[0].children.filter((child) => child.name.substring(0, 4) === ("HemFinishing").substring(0, 4))[0];
            //   side_Pockets = model.children[0].children.filter((child) => child.name.substring(0, 4) === ("Sidepockets").substring(0, 4))[0];
            //   back_Pockets = model.children[0].children.filter((child) => child.name.substring(0, 4) === ("Backpocket").substring(0, 4))[0];

            //   update_Hem_finishing(Hem_finishing_value);
            //   update_Coin_Pocket(coin_pocket_value)
            //   update_Pleats(Pleat);
            //   update_side_Pockets(pocket_side, TAMF_Size);
            //   update_Back_Pockets(pockets_back);

            //   update_Waistband(waistband_value, waistband_height);
            //   update_Fasteting(fasteting_value, waistband_value, waistband_height);
        } else if (waistecoatdiv.classList.contains("isSelected")) {
            document.body.classList.add("line-loading-3d-preview");
            //loadLodingText();
            loadGLTFmoadl("Waistcoat");
            waistcoatactive = true;
            trouseractive = false;
            jacketactive = false;

            // scene.children.forEach(child => {
            //     scene.remove(child);
            // });
            // scene.add(loadGLTFmoadl('Waistcoat'));
            // model && updateMaterialFabricWaistcoat(fabric)
            // // loadGLTFmoadl('Waistcoat');
            // Collar_Styles = model.children[0].children.filter((child) => child.name.substring(0, 4) === ("buttonning").substring(0, 4))[0];
            // Wback_Pockets = model.children[0].children.filter((child) => child.name.substring(0, 4) === ("back").substring(0, 4))[0];
            // WChest_Pocket = model.children[0].children.filter((child) => child.name.substring(0, 4) === ("Chest_pocket").substring(0, 4))[0];
            // WSide_pocket = model.children[0].children.filter((child) => child.name.substring(0, 4) === ("Side_pocket").substring(0, 4))[0];

            // updateSidePockets(pocketSide);
            // updateChestPockets(pocketsBack);
            // updateCollarStyles(collarStyle);
            // updateBackColor(backColor)
        } else if (jacketdiv.classList.contains("isSelected")) {
            document.body.classList.add("line-loading-3d-preview");
            // scene.children.forEach(child => {
            //     scene.remove(child);
            // });
            //loadLodingText();
            loadGLTFmoadl(intialmodel);
            // model && updateMaterialFabric(responsestatic.data);
            // // loadGLTFmoadl(intialmodel);
            // Lapel_style = model.children.filter((child) => child.name.substring(0, 4).toUpperCase() === ("Lapel_style").substring(0, 4).toUpperCase())[0];
            //   Lining = model.children.filter((child) => child.name.substring(0, 4) === ("Lining").substring(0, 4))[0];
            //   Shoulders = model.children.filter((child) => child.name.substring(0, 4) === ("Shoulders").substring(0, 4))[0];
            //   Chest_Pocket = model.children.filter((child) => child.name.substring(0, 4) === ("Chest_Pocket").substring(0, 4))[0];
            //   Side_pocket = model.children.filter((child) => child.name.substring(0, 4) === ("Side_pocket").substring(0, 4))[0];
            //   Ticket_pockets = model.children.filter((child) => child.name.substring(0, 4) === ("Ticket_pockets").substring(0, 4))[0];
            //   buttons = model.children.filter((child) => child.name.substring(0, 4) === "buttons".substring(0, 4))[0];

            //   update_Lapel_width(sLapelstyle, sLapelwidth, sLapel_buttonhole, sAMF, sLapel_button_hole_Position);
            //   update_Chest_Pocket(sChest_Pocket);
            //   update_Side_Pocket(sSide_pocket);
            //   update_Ticket_pockets(sSide_pocket);
            //   update_Lining(sLining);
            //   update_Sleeve_Button(sSleeve_button, sChest_Pocket, sSide_pocket);
            //   update_Shoulders(sShoulders);
            //   update_Vent(sVent, sAMF, sShoulders);
            //   Shoulders.children.filter((child) => child.name === "spalla_camicia_2mm")[0].material.depthWrite = true;
            //   Shoulders.children.filter((child) => child.name === "spalla_camicia_2mm")[0].material.trnsprant = false;
            //   sCurruntFabric && updateMaterialFabric(sCurruntFabric);
            //   //console.log("test")
            jacketactive = true;
            waistcoatactive = false;
            trouseractive = false;
        }
    }, 100);
}
);
function modelvales(obj) {
    setTimeout(() => {
        //console.log(11111);
        // Get all the parent divs with the class "cm-modifier-card-container"
        //let parentDivs = document.querySelector(".cm-progress-container.isSelected").querySelectorAll(".cm-modifier-card-container");
        let parentDivs = document.querySelectorAll(".cm-modifier-card-container");
        let resultTitleText, resultTitleTextWithoutSpaces, childDiv, resultTitleDiv, filter_label, filter_label_value;

        if (dataPageValue == "custom-made-trouser") {
            // Iterate through each parent div for Trouser model
            for (let i = 0; i < parentDivs.length; i++) {
                // Get the child div with the class "cm-modifier-card-wrapper"
                childDiv = parentDivs[i].querySelector(".cm-modifier-card-wrapper");
                // Check if the child div exists
                if (childDiv) {
                    // Access data or perform actions on the child div
                    //console.log("i" + i + childDiv.textContent); // For example, logging the text content of each card wrapper
                    filter_label = childDiv.querySelector(".cm-modifier-col-title");
                    // Find the children div with class "cm-modifier-result-title" within childDiv
                    resultTitleDiv = childDiv.querySelector(".cm-modifier-result-title");

                    if (resultTitleDiv) {
                        resultTitleText = resultTitleDiv.textContent.trim(); // Remove leading and trailing spaces
                        filter_label_value = filter_label.textContent.trim();
                        resultTitleTextWithoutSpaces = resultTitleText.replace(
                            /[.\s:]+/g,
                            "_"
                        ); // Replace spaces and dots with underscores
                        filter_label_value = filter_label_value.replace(
                            /[.\s:]+/g,
                            "_"
                        );
                        console.log("Result ::" + resultTitleTextWithoutSpaces + filter_label_value); // Log the modified text content
                    }

                    
                    if (filter_label_value == 'Waistband') {
                        if (resultTitleTextWithoutSpaces == "Straight") {
                            resultTitleTextWithoutSpaces = "Oscar_Straight";
                        } else if (resultTitleTextWithoutSpaces == "Straight_Extended") {
                            resultTitleTextWithoutSpaces = "Oscar_Straight_Extended";
                        }  else if (resultTitleTextWithoutSpaces == "Peak") {
                            resultTitleTextWithoutSpaces = "Oscar_Peak";
                        } else if (resultTitleTextWithoutSpaces == "Peak_Extended") {
                            resultTitleTextWithoutSpaces = "Oscar_Peak_Extended";
                        } else if (resultTitleTextWithoutSpaces == "Drawstring") {
                            resultTitleTextWithoutSpaces = "DrawString";
                        } else if (resultTitleTextWithoutSpaces == "Original_Gurkha") {
                            resultTitleTextWithoutSpaces = "Gurkha_double";
                        }
                        waistband_value = resultTitleTextWithoutSpaces;
                    }
                    if (filter_label_value == 'Waistband_height') {

                        console.log("Waistband_height :: ",resultTitleTextWithoutSpaces)

                        if (resultTitleTextWithoutSpaces == "Low_(3_5_cm_/_1_4_in)") {
                            waistband_height = 0;
                        } else if (resultTitleTextWithoutSpaces == "Mid_(4_cm_/_1_6_in)") {
                            waistband_height = 1;
                        } else if (resultTitleTextWithoutSpaces == "High_(5_cm_/_2_0_in)") {
                            waistband_height = 2;
                        }
                    }
                    if (filter_label_value == 'Fastening') {
                        if (resultTitleTextWithoutSpaces == "None") {
                            resultTitleTextWithoutSpaces = "None";
                        } else if (resultTitleTextWithoutSpaces == "Belt_loops") {
                            resultTitleTextWithoutSpaces = "Belt";
                        } else if (resultTitleTextWithoutSpaces == "Side_adjusters") {
                            resultTitleTextWithoutSpaces = "Side_adjusters_";
                        } else if (
                            resultTitleTextWithoutSpaces == "Lowered_Side_adjusters"
                        ) {
                            resultTitleTextWithoutSpaces = "Lower_Side_adjusters";
                        }
                        fasteting_value = resultTitleTextWithoutSpaces;
                    }
                    if (filter_label_value == 'Coin_pocket') {
                        if (resultTitleTextWithoutSpaces == "Yes") {
                            coin_pocket_value = true;
                        } else if (resultTitleTextWithoutSpaces == "No") {
                            coin_pocket_value = false;
                        }
                    }
                    if (i == 4) {
                    }
                    if (filter_label_value == 'Pleats') {

                        if (resultTitleTextWithoutSpaces == "No_pleats") {
                            resultTitleTextWithoutSpaces = "Normal_straight_pant";
                        } else if (resultTitleTextWithoutSpaces == "Single_Pleats_(Outward)") {
                            resultTitleTextWithoutSpaces = "Standardsinglee";
                        } else if (resultTitleTextWithoutSpaces == "Double_Pleats_(Outward)") {
                            resultTitleTextWithoutSpaces = "StandardDouble";
                        } else if (resultTitleTextWithoutSpaces == "Single_Pleats_(Inward)") {
                            resultTitleTextWithoutSpaces = "INWARDSINGLE";
                        } else if (resultTitleTextWithoutSpaces == "Double_Pleats_(Inward)") {
                            resultTitleTextWithoutSpaces = "INWARDDouble";
                        }
                        Pleat = resultTitleTextWithoutSpaces;
                    }
                    if (filter_label_value == 'Hem_finishing') {
                        if (resultTitleTextWithoutSpaces == "Plain") {
                            resultTitleTextWithoutSpaces = "None";
                        } else if (resultTitleTextWithoutSpaces == "Cuffed_hem_(6_cm_/_2_4_in)") {
                            resultTitleTextWithoutSpaces = "HemFinishing6CM";
                        } else if (resultTitleTextWithoutSpaces == "Cuffed_hem_(5_cm_/_2_in)") {
                            resultTitleTextWithoutSpaces = "HemFinishing5CM";
                        } else if (resultTitleTextWithoutSpaces == "Cuffed_hem_(4_cm_/_1_6_in)") {
                            resultTitleTextWithoutSpaces = "HemFinishing4CM";
                        }
                        Hem_finishing_value = resultTitleTextWithoutSpaces;
                    }
                    if (filter_label_value == 'AMF_Stiching') {
                        if (resultTitleTextWithoutSpaces == "2_mm_(Standard)") {
                        resultTitleTextWithoutSpaces = "AMF_2";
                        } else if (resultTitleTextWithoutSpaces == "6_mm") {
                            resultTitleTextWithoutSpaces = "AMF_6";
                        }
                        TAMF_Size = resultTitleTextWithoutSpaces;
                    }
                    if (filter_label_value == 'Side_pockets') {
                        pocket_side = resultTitleTextWithoutSpaces;
                    }
                    if (filter_label_value == 'Back_pockets') {
                        console.log("resultTitleTextWithoutSpaces Back_pockets",resultTitleTextWithoutSpaces)
                        if (resultTitleTextWithoutSpaces == "Jetted_with_button") {
                            resultTitleTextWithoutSpaces = "jetted_Button";
                        } else if (resultTitleTextWithoutSpaces == "Jetted_without_button") {
                            resultTitleTextWithoutSpaces = "jetted_no_Button";
                        } else if (resultTitleTextWithoutSpaces == "Jetted_No_Button") {
                            resultTitleTextWithoutSpaces = "jetted_no_Button";
                        }
                        pockets_back = resultTitleTextWithoutSpaces;
                    }
                }
                if (filter_label_value == 'Buttons') {
                    sButtons_texture = resultTitleTextWithoutSpaces;
                    updateButtonImage(coin_Pocket.children[0].children[0].material);
                }
                //console.log(fasteting_value);
                update_Fasteting(fasteting_value, waistband_value, waistband_height);
                console.log("Hem_finishing_value",Hem_finishing_value)
                update_Hem_finishing(Hem_finishing_value);
                update_Coin_Pocket(coin_pocket_value);
                update_Pleats(Pleat);
                update_side_Pockets(pocket_side, TAMF_Size);
                update_Back_Pockets(pockets_back);
                update_Waistband(waistband_value, waistband_height);
            }
        }
        else if (dataPageValue == "custom-made-waistcoat") {
            // Iterate through each parent div for Waistcoat model
            for (let i = 0; i < parentDivs.length; i++) {
                // Get the child div with the class "cm-modifier-card-wrapper"
                childDiv = parentDivs[i].querySelector(".cm-modifier-card-wrapper");
                // Check if the child div exists
                if (childDiv) {
                    // Access data or perform actions on the child div
                    //console.log("i" + i + childDiv.textContent); // For example, logging the text content of each card wrapper

                    // Find the children div with class "cm-modifier-result-title" within childDiv
                    filter_label = childDiv.querySelector(".cm-modifier-col-title");
                    resultTitleDiv = childDiv.querySelector(".cm-modifier-result-title");

                    if (resultTitleDiv) {
                        resultTitleText = resultTitleDiv.textContent.trim(); // Remove leading and trailing spaces
                        filter_label_value = filter_label.textContent.trim();
                        resultTitleTextWithoutSpaces = resultTitleText.replace(
                            /[.\s:]+/g,
                            "_"
                        ); // Replace spaces and dots with underscores
                        filter_label_value = filter_label_value.replace(
                            /[.\s:]+/g,
                            "_"
                        );
                        console.log("Result Title: " + resultTitleTextWithoutSpaces); // Log the modified text content
                        console.log("Result Label:" + filter_label_value)
                    }

                    if (waistecoatdiv.classList.contains("isSelected")) {
                        //console.log("in if");
                        if (i == 1) {
                            if (resultTitleTextWithoutSpaces == "Single_Breasted_4_buttons") {
                                resultTitleTextWithoutSpaces = "Single_Breasted_4_V_Shape";
                            } else if (
                                resultTitleTextWithoutSpaces == "Single_Breasted_5_buttons"
                            ) {
                                resultTitleTextWithoutSpaces = "Single_Breasted_5_V_Shape";
                            } else if (
                                resultTitleTextWithoutSpaces == "Single_Breasted_6_buttons"
                            ) {
                                resultTitleTextWithoutSpaces = "Single_Breasted_6_V_Shape";
                            } else if (
                                resultTitleTextWithoutSpaces == "Double_Breasted_6_buttons"
                            ) {
                                resultTitleTextWithoutSpaces = "Double_Breasted_6_button_V";
                            }
                            buttoning = resultTitleTextWithoutSpaces;
                        }
                        if (i == 2) {
                            if (resultTitleTextWithoutSpaces == "V_shape") {
                                resultTitleTextWithoutSpaces = "None";
                            } else if (resultTitleTextWithoutSpaces == "Notch_Lapel") {
                                resultTitleTextWithoutSpaces = "Notch";
                            } else if (resultTitleTextWithoutSpaces == "Peak_Lapel") {
                                resultTitleTextWithoutSpaces = "Peak";
                            } else if (resultTitleTextWithoutSpaces == "Horse_shoe") {
                                resultTitleTextWithoutSpaces = "Horse";
                            }
                            collarStyle = resultTitleTextWithoutSpaces;
                        }
                        if (i == 3) {
                            if (resultTitleTextWithoutSpaces == "Single_Pocket") {
                                resultTitleTextWithoutSpaces = "Single_pocket";
                            } else if (resultTitleTextWithoutSpaces == "Dual_Pockets") {
                                resultTitleTextWithoutSpaces = "Double_pocket";
                            }
                            pocketsBack = resultTitleTextWithoutSpaces;
                        }
                        if (i == 4) {
                            if (resultTitleTextWithoutSpaces == "Straight_Pocket") {
                                resultTitleTextWithoutSpaces = "Straight_pocket";
                            } else if (resultTitleTextWithoutSpaces == "Jetted_Pocket") {
                                resultTitleTextWithoutSpaces = "Jetted_pocket";
                            }
                            pocketSide = resultTitleTextWithoutSpaces;
                        }
                        if (i == 5) {
                            if (resultTitleTextWithoutSpaces == "2mm_(Standard)") {
                                resultTitleTextWithoutSpaces = "AMF_2";
                            } else if (resultTitleTextWithoutSpaces == "6mm") {
                                resultTitleTextWithoutSpaces = "AMF_6";
                            }
                            wAMF = resultTitleTextWithoutSpaces;
                        }
                        if (filter_label_value == "Buttons") {
                            sButtons_texture = resultTitleTextWithoutSpaces;
                            updateButtonImage(Collar_Styles.children[0].children[1].material);
                        }

                        if (i == 8) {
                            // if (resultTitleTextWithoutSpaces == "White") {
                            //   resultTitleTextWithoutSpaces = "#ffffff";
                            // } else if (resultTitleTextWithoutSpaces == "Light_Grey") {
                            //   resultTitleTextWithoutSpaces = "#4d4d54";
                            // } else if (resultTitleTextWithoutSpaces == "Dark_Grey") {
                            //   resultTitleTextWithoutSpaces = "#282024";
                            // } else if (resultTitleTextWithoutSpaces == "Light_Blue") {
                            //   resultTitleTextWithoutSpaces = "#40546b";
                            // } else if (resultTitleTextWithoutSpaces == "Pink") {
                            //   resultTitleTextWithoutSpaces = "#c72b52";
                            // }
                            backColor = getLiningColor(resultTitleTextWithoutSpaces);
                        }

                        // if (i == 7) {

                        // }
                    } else {

                        if (filter_label_value == "Buttons") {
                            console.log("texture name",resultTitleTextWithoutSpaces)
                            sButtons_texture = resultTitleTextWithoutSpaces;
                            updateButtonImage(Collar_Styles.children[0].children[1].material);
                        }

                        if (filter_label_value == "Lining_choice") {
                            backColor = getLiningColor(resultTitleTextWithoutSpaces);
                        }

                        if (i == 0) {
                            if (resultTitleTextWithoutSpaces == "Single_Breasted_4_buttons") {
                                resultTitleTextWithoutSpaces = "Single_Breasted_4_V_Shape";
                            } else if (
                                resultTitleTextWithoutSpaces == "Single_Breasted_5_buttons"
                            ) {
                                resultTitleTextWithoutSpaces = "Single_Breasted_5_V_Shape";
                            } else if (
                                resultTitleTextWithoutSpaces == "Single_Breasted_6_buttons"
                            ) {
                                resultTitleTextWithoutSpaces = "Single_Breasted_6_V_Shape";
                            } else if (
                                resultTitleTextWithoutSpaces == "Double_Breasted_6_buttons"
                            ) {
                                resultTitleTextWithoutSpaces = "Double_Breasted_6_button_V";
                            }
                            buttoning = resultTitleTextWithoutSpaces;
                        }
                        if (i == 1) {
                            if (resultTitleTextWithoutSpaces == "V_shape") {
                                resultTitleTextWithoutSpaces = "None";
                            } else if (resultTitleTextWithoutSpaces == "Notch_Lapel") {
                                resultTitleTextWithoutSpaces = "Notch";
                            } else if (resultTitleTextWithoutSpaces == "Peak_Lapel") {
                                resultTitleTextWithoutSpaces = "Peak";
                            } else if (resultTitleTextWithoutSpaces == "Horse_shoe") {
                                resultTitleTextWithoutSpaces = "Horse";
                            }
                            collarStyle = resultTitleTextWithoutSpaces;
                        }
                        if (i == 2) {
                            if (resultTitleTextWithoutSpaces == "Single_Pocket") {
                                resultTitleTextWithoutSpaces = "Single_pocket";
                            } else if (resultTitleTextWithoutSpaces == "Dual_Pockets") {
                                resultTitleTextWithoutSpaces = "Double_pocket";
                            }
                            pocketsBack = resultTitleTextWithoutSpaces;
                        }
                        if (i == 3) {
                            if (resultTitleTextWithoutSpaces == "Straight_Pocket") {
                                resultTitleTextWithoutSpaces = "Straight_pocket";
                            } else if (resultTitleTextWithoutSpaces == "Jetted_Pocket") {
                                resultTitleTextWithoutSpaces = "Jetted_pocket";
                            }
                            pocketSide = resultTitleTextWithoutSpaces;
                        }
                        if (i == 4) {
                            if (resultTitleTextWithoutSpaces == "2mm_(Standard)") {
                                resultTitleTextWithoutSpaces = "AMF_2";
                            } else if (resultTitleTextWithoutSpaces == "6mm") {
                                resultTitleTextWithoutSpaces = "AMF_6";
                            }
                            wAMF = resultTitleTextWithoutSpaces;
                        }
                        if (i == 5) {
                            backStyle = resultTitleTextWithoutSpaces;
                        }
                    }
                }
                //
                updateSidePockets(pocketSide);
                updateChestPockets(pocketsBack);
                updateCollarStyles(collarStyle);
                updateBackColor(backColor);
            }
        }
        else if (dataPageValue == "custom-made-suit") {
            if (jacketdiv.classList.contains("isSelected")) {
                for (let i = 0; i <= 16; i++) {
                    // Get the child div with the class "cm-modifier-card-wrapper"
                    childDiv = parentDivs[i].querySelector(".cm-modifier-card-wrapper");
                    // Check if the child div exists
                    if (childDiv) {
                        // Access data or perform actions on the child div
                        //console.log("i" + i + childDiv.textContent); // For example, logging the text content of each card wrapper
                        filter_label = childDiv.querySelector(".cm-modifier-col-title");
                        // Find the children div with class "cm-modifier-result-title" within childDiv
                        resultTitleDiv = childDiv.querySelector(
                            ".cm-modifier-result-title"
                        );

                        if (resultTitleDiv) {
                            resultTitleText = resultTitleDiv.textContent.trim(); // Remove leading and trailing spaces
                            filter_label_value = filter_label.textContent.trim();
                            resultTitleTextWithoutSpaces = resultTitleText.replace(
                                /[.\s:]+/g,
                                "_"
                            ); // Replace spaces and dots with underscores
                            filter_label_value = filter_label_value.replace(
                                /[.\s:]+/g,
                                "_"
                            );
                            console.log("Result Title: ", i, filter_label_value, resultTitleTextWithoutSpaces); // Log the modified text content
                        }
                        if (filter_label_value == 'Buttoning') {
                            intialmodel = resultTitleTextWithoutSpaces;
                            let activediv = childDiv.querySelector(
                                ".cm-modifier-card-content"
                            );
                            if (activediv.classList.contains("active-option")) {
                                // console.log(newresultTitleDiv);
                                //loadLodingText();
                                $("body").addClass("line-loading-3d-preview");
                                if (
                                    resultTitleTextWithoutSpaces == "Single_Breasted_1_button"
                                ) {
                                    resultTitleTextWithoutSpaces = "Single_Breasted_1_button1";
                                }
                                loadGLTFmoadl(resultTitleTextWithoutSpaces);
                            }
                        }
                        if (filter_label_value == 'Lapel_style') {
                            resultTitleDiv = resultTitleDiv.textContent.trim().toLowerCase();
                            //console.log(resultTitleDiv);
                            sLapelstyle = resultTitleDiv;
                            //console.log("updating lapel width", sLapelstyle)
                            update_Lapel_width(
                                sLapelstyle,
                                sLapelwidth,
                                sLapel_buttonhole,
                                sAMF,
                                sLapel_button_hole_Position
                            );
                        }
                        if (filter_label_value == 'Lapel_Width') {
                            resultTitleDiv = resultTitleDiv.textContent.trim().toLowerCase();
                            //console.log(resultTitleDiv);
                            // sLapelstyle = resultTitleDiv
                            sLapelwidth = resultTitleDiv;
                            //console.log(sLapelwidth);
                        }
                        if (filter_label_value == 'Vent') {
                            resultTitleDiv = resultTitleDiv.textContent.trim().toLowerCase();
                            //console.log(resultTitleDiv);
                            // sLapelstyle = resultTitleDiv

                            sVent = resultTitleDiv;
                        }                        
                        if (filter_label_value == 'Shoulder') {
                            if (
                                resultTitleTextWithoutSpaces ==
                                "Rope_Shoulder_-_Structured_(5_mm)"
                            ) {
                                resultTitleTextWithoutSpaces = "Rounded_Shoulder_5mm";
                            } else if (
                                resultTitleTextWithoutSpaces ==
                                "Rope_Shoulder_-_Lightly_Padded_(2_mm)"
                            ) {
                                resultTitleTextWithoutSpaces = "Rounded_Shoulder_2mm";
                            } else if (
                                resultTitleTextWithoutSpaces ==
                                "Natural_Shoulder_-_Structured_(5_mm)"
                            ) {
                                resultTitleTextWithoutSpaces = "Natural_Shoulder_5mm";
                            } else if (
                                resultTitleTextWithoutSpaces ==
                                "Natural_Shoulder_-_Lightly_Padded_(2_mm)"
                            ) {
                                resultTitleTextWithoutSpaces = "Natural_Shoulder_2mm";
                            } else if (
                                resultTitleTextWithoutSpaces ==
                                "Natural_Shoulder_-_Unconstructed_(0_mm)"
                            ) {
                                resultTitleTextWithoutSpaces = "Natural_Shoulder_0mm";
                            } else if (
                                resultTitleTextWithoutSpaces ==
                                "La_Spalla_Camicia_-_Lightly_Padded_(2_mm)"
                            ) {
                                resultTitleTextWithoutSpaces = "spalla_camicia_2mm";
                            } else if (
                                resultTitleTextWithoutSpaces ==
                                "La_Spalla_Camicia_-_Unconstrcuted_(0_mm)"
                            ) {
                                resultTitleTextWithoutSpaces = "spalla_camicia_0mm";
                            }
                            sShoulders = resultTitleTextWithoutSpaces;
                        }
                        if (i == 6) {
                            if (resultTitleTextWithoutSpaces == "2_mm_(Standard)") {
                                resultTitleTextWithoutSpaces = "mm2";
                            } else if (resultTitleTextWithoutSpaces == "6_mm") {
                                resultTitleTextWithoutSpaces = "mm6";
                            }
                            sAMF = resultTitleTextWithoutSpaces;
                            //console.log(sAMF);
                        }
                        if (filter_label_value == 'Chest_pocket') {
                            if (resultTitleTextWithoutSpaces == "Boat") {
                                resultTitleTextWithoutSpaces = "Boat_Shape";
                            } else if (resultTitleTextWithoutSpaces == "Patch") {
                                resultTitleTextWithoutSpaces = "patch";
                            } else if (resultTitleTextWithoutSpaces == "Rounded_patch") {
                                resultTitleTextWithoutSpaces = "Rounded";
                            } else if (resultTitleTextWithoutSpaces == "Pleat_patch") {
                                resultTitleTextWithoutSpaces = "pleat_B";
                            }
                            sChest_Pocket = resultTitleTextWithoutSpaces;
                        }
                        if (filter_label_value == 'Side_pockets') {

                            if (resultTitleTextWithoutSpaces == "Slanted_flap") {
                                resultTitleTextWithoutSpaces = "Slanted_Flap001";
                            } else if (resultTitleTextWithoutSpaces == "Jetted") {
                                resultTitleTextWithoutSpaces = "Jetted001";
                            } else if (resultTitleTextWithoutSpaces == "Slanted_Jetted") {
                                resultTitleTextWithoutSpaces = "Slanted_Jetted001";
                            } else if (resultTitleTextWithoutSpaces == "Patch") {
                                resultTitleTextWithoutSpaces = "patch001";
                            } else if (resultTitleTextWithoutSpaces == "Rounded_patch") {
                                resultTitleTextWithoutSpaces = "Rounded_Patch";
                            } else if (resultTitleTextWithoutSpaces == "Pleat_patch") {
                                resultTitleTextWithoutSpaces = "Pleat_Patch";
                            }

                            side_pocket_value = resultTitleTextWithoutSpaces;
                        }
                        if (filter_label_value == 'Ticket_pocket') {
                            if (resultTitleTextWithoutSpaces == "Yes") {
                                Ticket_pocket_value = true;
                            } else {
                                Ticket_pocket_value = false;
                            }
                        }
                        if (filter_label_value == 'Buttons') {
                            sButtons_texture = resultTitleTextWithoutSpaces;
                            updateButtonImage(buttons.children[3].children[1].material);
                        }
                        if (filter_label_value == 'Cuffed_sleeve') {
                            if (resultTitleTextWithoutSpaces == "Yes") {
                                Cuffed_sleeve_value = true;
                            } else {
                                Cuffed_sleeve_value = false;
                            }
                        }
                        if (filter_label_value == 'Sleeve_buttons') {
                            if (resultTitleTextWithoutSpaces == "1_sleeve_button") {
                                resultTitleTextWithoutSpaces = "sleeve_button_1";
                            } else if (resultTitleTextWithoutSpaces == "3_kissing") {
                                resultTitleTextWithoutSpaces = "kissing_3";
                            } else if (resultTitleTextWithoutSpaces == "3_non-kissing") {
                                resultTitleTextWithoutSpaces = "non_kissing_3";
                            } else if (resultTitleTextWithoutSpaces == "4_kissing") {
                                resultTitleTextWithoutSpaces = "kissing_4";
                            } else if (resultTitleTextWithoutSpaces == "4_non-kissing") {
                                resultTitleTextWithoutSpaces = "non_kissing_4";
                            } else if (
                                resultTitleTextWithoutSpaces == "5_kissing"
                            ) {
                                resultTitleTextWithoutSpaces = "kissing_5";
                            } else if (resultTitleTextWithoutSpaces == "5_non-kissing") {
                                resultTitleTextWithoutSpaces = "non_kissing_5";
                            }
                            sSleeve_button = resultTitleTextWithoutSpaces;
                        }
                        if (filter_label_value == 'Buttonhole_lapel_position') {
                            if (resultTitleTextWithoutSpaces == "Left_(Standard)") {
                                resultTitleTextWithoutSpaces = "right";
                            } else if (resultTitleTextWithoutSpaces == "Right") {
                                resultTitleTextWithoutSpaces = "left";
                            }
                            sLapel_button_hole_Position = resultTitleTextWithoutSpaces;
                        }
                        if (filter_label_value == 'Buttonhole_lapel') {
                            if (resultTitleTextWithoutSpaces == "Traditional") {
                                resultTitleTextWithoutSpaces = "Handmade";
                            } else if (resultTitleTextWithoutSpaces == "milanese") {
                                resultTitleTextWithoutSpaces = "Traditional";
                            }
                            sLapel_buttonhole = resultTitleTextWithoutSpaces;
                        }
                        if (filter_label_value == 'Lining') {
                            if (resultTitleTextWithoutSpaces == "Half_Lined") {
                                resultTitleTextWithoutSpaces = "halfline";
                            } else if (resultTitleTextWithoutSpaces == "Fully_Lined") {
                                resultTitleTextWithoutSpaces = "full";
                            }
                            sLining = resultTitleTextWithoutSpaces;
                        }
                        if (filter_label_value == 'Lining_colour') {
                            // if (resultTitleTextWithoutSpaces == "White") {
                            //   sLiningColor = "#ffffff";
                            // } else if (resultTitleTextWithoutSpaces == "Light_Grey") {
                            //   sLiningColor = "#4d4d54";
                            // } else if (resultTitleTextWithoutSpaces == "Dark_Grey") {
                            //   sLiningColor = "#282024";
                            // } else if (resultTitleTextWithoutSpaces == "Light_Blue") {
                            //   sLiningColor = "#40546b";
                            // } else if (resultTitleTextWithoutSpaces == "Pink") {
                            //   sLiningColor = "#c72b52";
                            // }
                            // console.log(
                            //   "update_lining_color",
                            //   resultTitleTextWithoutSpaces
                            // );
                            sLiningColor = getLiningColor(resultTitleTextWithoutSpaces);

                            update_lining_color();
                        }
                    }
                    // update_Lapel_width(
                    //   sLapelstyle,
                    //   sLapelwidth,
                    //   sLapel_buttonhole,
                    //   sAMF,
                    //   sLapel_button_hole_Position
                    // );

                    update_Chest_Pocket(sChest_Pocket);
                    update_Side_Pocket(side_pocket_value);
                    update_Ticket_pockets(side_pocket_value);
                    update_Lining(sLining);
                    update_Sleeve_Button(
                        sSleeve_button,
                        sChest_Pocket,
                        side_pocket_value
                    );
                    update_Shoulders(sShoulders);
                    update_Vent(sVent, sAMF, sShoulders);
                    update_Cuffed_sleeve(Cuffed_sleeve_value);
                }
            }
            else if (trouserdiv.classList.contains("isSelected")) {
                for (let i = 19; i < 33; i++) {
                    childDiv = parentDivs[i].querySelector(".cm-modifier-card-wrapper");

                    // Check if the child div exists
                    if (childDiv) {
                        // Access data or perform actions on the child div
                        //console.log("i" + i + childDiv.textContent); // For example, logging the text content of each card wrapper

                        // Find the children div with class "cm-modifier-result-title" within childDiv
                        resultTitleDiv = childDiv.querySelector(
                            ".cm-modifier-result-title"
                        );

                        if (resultTitleDiv) {
                            resultTitleText = resultTitleDiv.textContent.trim(); // Remove leading and trailing spaces
                            resultTitleTextWithoutSpaces = resultTitleText.replace(
                                /[.\s:]+/g,
                                "_"
                            ); // Replace spaces and dots with underscores
                            //console.log("Result Title: " + resultTitleTextWithoutSpaces); // Log the modified text content
                        }
                        if (i == 19) {
                            if (
                                resultTitleTextWithoutSpaces == "Oscar_Straight_[7_cm_overlap]"
                            ) {
                                resultTitleTextWithoutSpaces = "Oscar_Straight";
                            } else if (
                                resultTitleTextWithoutSpaces ==
                                "Oscar_Straight_Extended_[11_cm_overlap]"
                            ) {
                                resultTitleTextWithoutSpaces = "Oscar_Straight_Extended";
                            } else if (
                                resultTitleTextWithoutSpaces ==
                                "Oscar_Straight_Extended_[11_cm_overlap]"
                            ) {
                                resultTitleTextWithoutSpaces = "Oscar_Straight_Extended";
                            } else if (
                                resultTitleTextWithoutSpaces == "Oscar_Peak_[7_cm_overlap]"
                            ) {
                                resultTitleTextWithoutSpaces = "Oscar_Peak";
                            } else if (
                                resultTitleTextWithoutSpaces ==
                                "Oscar_Peak_Extended_[11_cm_overlap]"
                            ) {
                                resultTitleTextWithoutSpaces = "Oscar_Peak_Extended";
                            } else if (resultTitleTextWithoutSpaces == "Drawstring") {
                                resultTitleTextWithoutSpaces = "DrawString";
                            } else if (resultTitleTextWithoutSpaces == "Original_Gurkha") {
                                resultTitleTextWithoutSpaces = "Gurkha_double";
                            }
                            waistband_value = resultTitleTextWithoutSpaces;
                        }
                        if (i == 20) {
                            if (resultTitleTextWithoutSpaces == "3_5_cm") {
                                waistband_height = 0;
                            } else if (resultTitleTextWithoutSpaces == "4_cm") {
                                waistband_height = 1;
                            } else if (resultTitleTextWithoutSpaces == "6_cm") {
                                waistband_height = 2;
                            }
                        }
                        if (i == 21) {
                            if (resultTitleTextWithoutSpaces == "None") {
                                resultTitleTextWithoutSpaces = "None";
                            } else if (resultTitleTextWithoutSpaces == "Belt_loop") {
                                resultTitleTextWithoutSpaces = "Belt";
                            } else if (resultTitleTextWithoutSpaces == "Side_adjusters_") {
                                resultTitleTextWithoutSpaces = "Side_adjusters_";
                            } else if (
                                resultTitleTextWithoutSpaces == "Lowered_side_adjusters"
                            ) {
                                resultTitleTextWithoutSpaces = "Lower_Side_adjusters";
                            }
                            fasteting_value = resultTitleTextWithoutSpaces;
                        }
                        if (i == 22) {
                            if (resultTitleTextWithoutSpaces == "Yes") {
                                coin_pocket_value = true;
                            } else if (resultTitleTextWithoutSpaces == "No") {
                                coin_pocket_value = false;
                            }
                        }
                        if (i == 23) {
                        }
                        if (i == 24) {
                            if (resultTitleTextWithoutSpaces == "No_pleats") {
                                resultTitleTextWithoutSpaces = "Normal_straight_pant";
                            } else if (
                                resultTitleTextWithoutSpaces == "Outward_Single_Pleats"
                            ) {
                                resultTitleTextWithoutSpaces = "Standardsinglee";
                            } else if (
                                resultTitleTextWithoutSpaces == "Outward_Double_Pleats"
                            ) {
                                resultTitleTextWithoutSpaces = "StandardDouble";
                            } else if (
                                resultTitleTextWithoutSpaces == "Inward_Single_Pleats"
                            ) {
                                resultTitleTextWithoutSpaces = "INWARDSINGLE";
                            } else if (
                                resultTitleTextWithoutSpaces == "Inward_Double_Pleats"
                            ) {
                                resultTitleTextWithoutSpaces = "INWARDDouble";
                            }
                            Pleat = resultTitleTextWithoutSpaces;
                        }
                        if (i == 25) {
                            if (resultTitleTextWithoutSpaces == "Plain") {
                                resultTitleTextWithoutSpaces = "None";
                            } else if (
                                resultTitleTextWithoutSpaces == "Turn_up_6_cm_/_2_4_inches_"
                            ) {
                                resultTitleTextWithoutSpaces = "HemFinishing6CM";
                            } else if (
                                resultTitleTextWithoutSpaces ==
                                "Turn_up_5_cm_/_2_inches_(Standard)"
                            ) {
                                resultTitleTextWithoutSpaces = "HemFinishing5CM";
                            } else if (
                                resultTitleTextWithoutSpaces == "Turn_up_4_cm/_1_6_inches_"
                            ) {
                                resultTitleTextWithoutSpaces = "HemFinishing4CM";
                            }
                            Hem_finishing_value = resultTitleTextWithoutSpaces;
                        }
                        if (i == 26) {
                            if (resultTitleTextWithoutSpaces == "2_mm_(Standard)") {
                                resultTitleTextWithoutSpaces = "AMF_2";
                            } else if (resultTitleTextWithoutSpaces == "6_mm") {
                                resultTitleTextWithoutSpaces = "AMF_6";
                            }
                            TAMF_Size = resultTitleTextWithoutSpaces;
                        }
                        if (i == 27) {
                            pocket_side = resultTitleTextWithoutSpaces;
                        }
                        if (i == 28) {
                            if (resultTitleTextWithoutSpaces == "Jetted") {
                                resultTitleTextWithoutSpaces = "jetted_Button";
                            } else if (resultTitleTextWithoutSpaces == "Jetted_No_Button") {
                                resultTitleTextWithoutSpaces = "jetted_no_Button";
                            } else if (resultTitleTextWithoutSpaces == "Jetted_No_Button") {
                                resultTitleTextWithoutSpaces = "jetted_no_Button";
                            }
                            pockets_back = resultTitleTextWithoutSpaces;
                        }
                        if (i == 29) {
                            sButtons_texture = resultTitleTextWithoutSpaces;
                            updateButtonImage(coin_Pocket.children[0].children[0].material);
                        }
                    }
                    update_Hem_finishing(Hem_finishing_value);
                    update_Coin_Pocket(coin_pocket_value);
                    update_Pleats(Pleat);
                    update_side_Pockets(pocket_side, TAMF_Size);
                    update_Back_Pockets(pockets_back);

                    update_Waistband(waistband_value, waistband_height);
                    update_Fasteting(fasteting_value, waistband_value, waistband_height);
                }
            }
            else if (waistecoatdiv.classList.contains("isSelected")) {
                for (let i = 33; i < 42; i++) {
                    childDiv = parentDivs[i].querySelector(".cm-modifier-card-wrapper");
                    // Check if the child div exists
                    if (childDiv) {
                        // Access data or perform actions on the child div
                        //console.log("i" + i + childDiv.textContent); // For example, logging the text content of each card wrapper

                        // Find the children div with class "cm-modifier-result-title" within childDiv
                        resultTitleDiv = childDiv.querySelector(
                            ".cm-modifier-result-title"
                        );

                        if (resultTitleDiv) {
                            resultTitleText = resultTitleDiv.textContent.trim(); // Remove leading and trailing spaces
                            resultTitleTextWithoutSpaces = resultTitleText.replace(
                                /[.\s:]+/g,
                                "_"
                            ); // Replace spaces and dots with underscores
                            // console.log("Result Title: " + resultTitleTextWithoutSpaces); // Log the modified text content
                        }
                        //console.log("in if");
                        if (i == 34) {
                            if (resultTitleTextWithoutSpaces == "Single_Breasted_4_buttons") {
                                resultTitleTextWithoutSpaces = "Single_Breasted_4_V_Shape";
                            } else if (
                                resultTitleTextWithoutSpaces == "Single_Breasted_5_buttons"
                            ) {
                                resultTitleTextWithoutSpaces = "Single_Breasted_5_V_Shape";
                            } else if (
                                resultTitleTextWithoutSpaces == "Single_Breasted_6_buttons"
                            ) {
                                resultTitleTextWithoutSpaces = "Single_Breasted_6_V_Shape";
                            } else if (
                                resultTitleTextWithoutSpaces == "Double_Breasted_6_buttons"
                            ) {
                                resultTitleTextWithoutSpaces = "Double_Breasted_6_button_V";
                            }
                            buttoning = resultTitleTextWithoutSpaces;
                        }
                        if (i == 35) {
                            if (resultTitleTextWithoutSpaces == "V_shape") {
                                resultTitleTextWithoutSpaces = "None";
                            } else if (resultTitleTextWithoutSpaces == "Notch_Lapel") {
                                resultTitleTextWithoutSpaces = "Notch";
                            } else if (resultTitleTextWithoutSpaces == "Peak_Lapel") {
                                resultTitleTextWithoutSpaces = "Peak";
                            } else if (resultTitleTextWithoutSpaces == "Horse_shoe") {
                                resultTitleTextWithoutSpaces = "Horse";
                            }
                            collarStyle = resultTitleTextWithoutSpaces;
                        }
                        if (i == 36) {
                            if (resultTitleTextWithoutSpaces == "Single_Pocket") {
                                resultTitleTextWithoutSpaces = "Single_pocket";
                            } else if (resultTitleTextWithoutSpaces == "Dual_Pockets") {
                                resultTitleTextWithoutSpaces = "Double_pocket";
                            }
                            pocketsBack = resultTitleTextWithoutSpaces;
                        }
                        if (i == 37) {
                            if (resultTitleTextWithoutSpaces == "Straight_Pocket") {
                                resultTitleTextWithoutSpaces = "Straight_pocket";
                            } else if (resultTitleTextWithoutSpaces == "Jetted_Pocket") {
                                resultTitleTextWithoutSpaces = "Jetted_pocket";
                            }
                            pocketSide = resultTitleTextWithoutSpaces;
                        }
                        if (i == 38) {
                            if (resultTitleTextWithoutSpaces == "2mm_(Standard)") {
                                resultTitleTextWithoutSpaces = "AMF_2";
                            } else if (resultTitleTextWithoutSpaces == "6mm") {
                                resultTitleTextWithoutSpaces = "AMF_6";
                            }
                            wAMF = resultTitleTextWithoutSpaces;
                        }
                        if (i == 39) {
                            backStyle = resultTitleTextWithoutSpaces;
                        }
                        if (i == 42) {
                            sButtons_texture = resultTitleTextWithoutSpaces;
                            updateButtonImage(Collar_Styles.children[0].children[1].material);
                        }
                        if (i == 40) {
                            sButtons_texture = resultTitleTextWithoutSpaces;
                            updateButtonImage(Collar_Styles.children[0].children[1].material);
                        }
                        if (i == 41) {
                            // if (resultTitleTextWithoutSpaces == "White") {
                            //   resultTitleTextWithoutSpaces = "#ffffff";
                            // } else if (resultTitleTextWithoutSpaces == "Light_Grey") {
                            //   resultTitleTextWithoutSpaces = "#4d4d54";
                            // } else if (resultTitleTextWithoutSpaces == "Dark_Grey") {
                            //   resultTitleTextWithoutSpaces = "#282024";
                            // } else if (resultTitleTextWithoutSpaces == "Light_Blue") {
                            //   resultTitleTextWithoutSpaces = "#40546b";
                            // } else if (resultTitleTextWithoutSpaces == "Pink") {
                            //   resultTitleTextWithoutSpaces = "#c72b52";
                            // }
                            backColor = getLiningColor(resultTitleTextWithoutSpaces);
                        }
                    }
                    //
                    updateSidePockets(pocketSide);
                    updateChestPockets(pocketsBack);
                    updateCollarStyles(collarStyle);
                    updateBackColor(backColor);
                }
            }
        }
        else if (dataPageValue == "custom-made-jacket") {
            // Iterate through each parent div for jacket model
            for (let i = 0; i < parentDivs.length; i++) {
                // Get the child div with the class "cm-modifier-card-wrapper"
                childDiv = parentDivs[i].querySelector(".cm-modifier-card-wrapper");
                // Check if the child div exists
                if (childDiv) {
                    // Access data or perform actions on the child div
                    //console.log("i" + i + childDiv.textContent); // For example, logging the text content of each card wrapper
                    filter_label = childDiv.querySelector(".cm-modifier-col-title");
                    // Find the children div with class "cm-modifier-result-title" within childDiv
                    resultTitleDiv = childDiv.querySelector(".cm-modifier-result-title");
                    // console.log("resultTitleDiv", resultTitleDiv)

                    if (resultTitleDiv) {
                        resultTitleText = resultTitleDiv.textContent.trim(); // Remove leading and trailing spaces
                        filter_label_value = filter_label.textContent.trim();
                        resultTitleTextWithoutSpaces = resultTitleText.replace(
                            /[.\s:]+/g,
                            "_"
                        ); // Replace spaces and dots with underscores
                        filter_label_value = filter_label_value.replace(
                            /[.\s:]+/g,
                            "_"
                        );
                        console.log("Result ::",`${filter_label_value} + ${resultTitleTextWithoutSpaces}`); // Log the modified text content
                    }
                    if (filter_label_value == 'Buttoning') {
                        let activediv = childDiv.querySelector(".cm-modifier-card-content");
                        if (activediv.classList.contains("active-option")) {
                            // console.log(newresultTitleDiv);
                            //loadLodingText();
                            $("body").addClass("line-loading-3d-preview");
                            if (resultTitleTextWithoutSpaces == "Single_Breasted_1_button") {
                                resultTitleTextWithoutSpaces = "Single_Breasted_1_button1";
                            }
                            if(resultTitleTextWithoutSpaces =="Double_Breasted_4_button_low"){
                                resultTitleTextWithoutSpaces = "Double_Breasted_4_button_low"
                            }

                            if(resultTitleTextWithoutSpaces =="Single_Breasted_2_button"){
                                resultTitleTextWithoutSpaces = "Single_Breasted_2_button"
                            }

                            // if(Single_Breasted_2_button)

                            console.log("resultTitleTextWithoutSpaces buttoning",resultTitleTextWithoutSpaces)
                            loadGLTFmoadl(resultTitleTextWithoutSpaces);
                        }
                    }
                    if (filter_label_value == 'Lapel_style') {
                        resultTitleDiv = resultTitleDiv.textContent.trim().toLowerCase();
                        console.log("Lapel_style ::",resultTitleTextWithoutSpaces);
                        sLapelstyle = resultTitleDiv;

                        if(resultTitleTextWithoutSpaces === "Notch_Peak"){
                            sLapelstyle = "notchpeak"
                        }
                        console.log("sLapelstyle:::",sLapelstyle)
                        console.log("sLapelwidth:::",sLapelwidth)
                        update_Lapel_width(
                            sLapelstyle,
                            sLapelwidth,
                            sLapel_buttonhole,
                            sAMF,
                            sLapel_button_hole_Position
                        );
                    }
                    if (filter_label_value == 'Lapel_Width') {
                        resultTitleDiv = resultTitleDiv.textContent.trim().toLowerCase();
                        console.log("resultTitleDiv Lapel_Width",resultTitleTextWithoutSpaces);

                        if(resultTitleTextWithoutSpaces === "Wide_(Standard)"){
                            resultTitleDiv = "wide"
                        }
                        if(resultTitleTextWithoutSpaces === "Mid"){
                            resultTitleDiv = "standerd"
                        }
                        // sLapelstyle = resultTitleDiv
                        sLapelwidth = resultTitleDiv;
                        //console.log(sLapelwidth);
                    }
                    if (filter_label_value == 'Vent') {
                        resultTitleDiv = resultTitleDiv.textContent.trim().toLowerCase();
                        //console.log(resultTitleDiv);
                        // sLapelstyle = resultTitleDiv

                        sVent = resultTitleDiv;
                    }
                    if (i == 4) {
                    }
                    if (filter_label_value == 'Shoulder') {
                        console.log("resultTitleTextWithoutSpaces : jacket",resultTitleTextWithoutSpaces)
                        if (
                            resultTitleTextWithoutSpaces ==
                            "Rope_Shoulder_-_Structured_(5_mm)"
                        ) {
                            resultTitleTextWithoutSpaces = "Rounded_Shoulder_5mm";
                        } else if (
                            resultTitleTextWithoutSpaces ==
                            "Rope_Shoulder_-_Lightly_Padded_(2_mm)"
                        ) {
                            resultTitleTextWithoutSpaces = "Rounded_Shoulder_2mm";
                        } else if (
                            resultTitleTextWithoutSpaces ==
                            "Natural_Shoulder_-_Structured_(5_mm)"
                        ) {
                            resultTitleTextWithoutSpaces = "Natural_Shoulder_5mm";
                        } else if (
                            resultTitleTextWithoutSpaces ==
                            "Natural_Shoulder_-_Lightly_Padded_(2_mm)"
                        ) {
                            resultTitleTextWithoutSpaces = "Natural_Shoulder_2mm";
                        } else if (
                            resultTitleTextWithoutSpaces ==
                            "Natural_Shoulder_-_Unconstructed_(0_mm)"
                        ) {
                            resultTitleTextWithoutSpaces = "Natural_Shoulder_0mm";
                        } else if (
                            resultTitleTextWithoutSpaces ==
                            "La_Spalla_Camicia_-_Lightly_Padded_(2_mm)"
                        ) {
                            resultTitleTextWithoutSpaces = "spalla_camicia_2mm";
                        } else if (
                            resultTitleTextWithoutSpaces ==
                            "La_Spalla_Camicia_-_Unconstructed_(0_mm)"
                        ) {
                            resultTitleTextWithoutSpaces = "spalla_camicia_0mm";
                        }
                        sShoulders = resultTitleTextWithoutSpaces;
                    }
                    if (filter_label_value == 'AMF') {
                        if (resultTitleTextWithoutSpaces == "2_mm_(Standard)") {
                            resultTitleTextWithoutSpaces = "mm2";
                        } else if (resultTitleTextWithoutSpaces == "6_mm") {
                            resultTitleTextWithoutSpaces = "mm6";
                        }
                        sAMF = resultTitleTextWithoutSpaces;
                        //console.log(sAMF);
                    }
                    if (filter_label_value == 'Chest_pocket') {
                        if (resultTitleTextWithoutSpaces == "Boat") {
                            resultTitleTextWithoutSpaces = "Boat_Shape";
                        } else if (resultTitleTextWithoutSpaces == "Patch") {
                            resultTitleTextWithoutSpaces = "patch";
                        } else if (resultTitleTextWithoutSpaces == "Rounded_patch") {
                            resultTitleTextWithoutSpaces = "Rounded";
                        } else if (resultTitleTextWithoutSpaces == "Pleat_patch") {
                            resultTitleTextWithoutSpaces = "pleat_B";
                        }
                        sChest_Pocket = resultTitleTextWithoutSpaces;
                    }
                    if (filter_label_value == 'Side_pockets') {
                        console.log('Side_pockets', resultTitleTextWithoutSpaces);
                        if (resultTitleTextWithoutSpaces == "Slanted_flap") {
                            resultTitleTextWithoutSpaces = "Slanted_Flap001";
                        } else if (resultTitleTextWithoutSpaces == "Jetted") {
                            resultTitleTextWithoutSpaces = "Jetted001";
                        } else if (resultTitleTextWithoutSpaces == "Slanted_Jetted") {
                            resultTitleTextWithoutSpaces = "Slanted_Jetted001";
                        } else if (resultTitleTextWithoutSpaces == "Patch") {
                            resultTitleTextWithoutSpaces = "patch001";
                        } else if (resultTitleTextWithoutSpaces == "Rounded_patch") {
                            resultTitleTextWithoutSpaces = "Rounded_Patch";
                        } else if (resultTitleTextWithoutSpaces == "Pleat_patch") {
                            resultTitleTextWithoutSpaces = "Pleat_Patch";
                        }

                        side_pocket_value = resultTitleTextWithoutSpaces;
                    }
                    if (filter_label_value == 'Ticket_pocket') {
                        if (resultTitleTextWithoutSpaces == "Yes") {
                            Ticket_pocket_value = true;
                        } else {
                            Ticket_pocket_value = false;
                        }
                    }
                    if (filter_label_value == 'Buttons') {
                        sButtons_texture = resultTitleTextWithoutSpaces;
                        //console.log("selected button texture", sButtons_texture)
                        //console.log("updating custom button", buttons.children[3].children[1].material)
                        updateButtonImage(buttons.children[3].children[1].material);
                        if (resultTitleTextWithoutSpaces == "3677KO") {
                        }
                        if (resultTitleTextWithoutSpaces == "C221-1G-(LIGHT-BROWN-MATT)") {
                        }
                        if (resultTitleTextWithoutSpaces == "H1178") {
                        }
                        if (resultTitleTextWithoutSpaces == "H010056-(DARK-GREY)") {
                        }
                        if (resultTitleTextWithoutSpaces == "MA0190-HG") {
                        }
                        if (resultTitleTextWithoutSpaces == "MAZ0232-ACK") {
                        }
                        if (
                            resultTitleTextWithoutSpaces == "MH1-(BLACK-WITH-SMALL-STAIN)"
                        ) {
                        }
                        if (resultTitleTextWithoutSpaces == "MH3-(DARK-BROWN)") {
                        }
                        if (resultTitleTextWithoutSpaces == "MH5-(LIGHT-BROWN)") {
                        }
                        if (resultTitleTextWithoutSpaces == "MT2733-(GOLD)") {
                        }
                        if (resultTitleTextWithoutSpaces == "MT2733-(SILVER)") {
                        }
                        if (resultTitleTextWithoutSpaces == "T17114H") {
                        }
                        if (
                            resultTitleTextWithoutSpaces ==
                            "C221-2G-(LIGHT-BROWN-WITH-TORTOISE-MARKS)"
                        ) {
                        }
                    }

                    if (filter_label_value == 'Cuffed_sleeve') {
                        if (resultTitleTextWithoutSpaces == "Yes") {
                            Cuffed_sleeve_value = true;
                        } else {
                            Cuffed_sleeve_value = false;
                        }
                    }
                    if (filter_label_value == 'Sleeve_buttons') {
                        if (resultTitleTextWithoutSpaces == "1_sleeve_button") {
                            resultTitleTextWithoutSpaces = "sleeve_button_1";
                        } else if (resultTitleTextWithoutSpaces == "3_kissing") {
                            resultTitleTextWithoutSpaces = "kissing_3";
                        } else if (resultTitleTextWithoutSpaces == "3_non-kissing") {
                            resultTitleTextWithoutSpaces = "non_kissing_3";
                        } else if (resultTitleTextWithoutSpaces == "4_kissing") {
                            resultTitleTextWithoutSpaces = "kissing_4";
                        } else if (resultTitleTextWithoutSpaces == "4_non-kissing") {
                            resultTitleTextWithoutSpaces = "non_kissing_4";
                        } else if (
                            resultTitleTextWithoutSpaces == "5_kissing"
                        ) {
                            resultTitleTextWithoutSpaces = "kissing_5";
                        } else if (resultTitleTextWithoutSpaces == "5_non-kissing") {
                            resultTitleTextWithoutSpaces = "non_kissing_5";
                        }
                        sSleeve_button = resultTitleTextWithoutSpaces;
                    }
                    if (filter_label_value == 'Buttonhole_lapel_position') {
                        if (resultTitleTextWithoutSpaces == "Left_(Standard)") {
                            resultTitleTextWithoutSpaces = "right";
                        } else if (resultTitleTextWithoutSpaces == "Right") {
                            resultTitleTextWithoutSpaces = "left";
                        }
                        sLapel_button_hole_Position = resultTitleTextWithoutSpaces;
                    }
                    if (filter_label_value == 'Buttonhole_lapel') {
                        if (resultTitleTextWithoutSpaces == "Traditional") {
                            resultTitleTextWithoutSpaces = "Handmade";
                        } else if (resultTitleTextWithoutSpaces == "Milanese") {
                            resultTitleTextWithoutSpaces = "Traditional";
                        }
                        sLapel_buttonhole = resultTitleTextWithoutSpaces;
                    }
                    if (filter_label_value == 'Lining') {
                        if (resultTitleTextWithoutSpaces == "Half_Lined") {
                            resultTitleTextWithoutSpaces = "halfline";
                        } else if (resultTitleTextWithoutSpaces == "Fully_Lined") {
                            resultTitleTextWithoutSpaces = "full";
                        }
                        sLining = resultTitleTextWithoutSpaces;
                    }
                    if (filter_label_value == 'Lining_colour') {
                        if (resultTitleTextWithoutSpaces == "White") {
                            sLiningColor = "#ffffff";
                        } else if (resultTitleTextWithoutSpaces == "Light_Grey") {
                            sLiningColor = "#4d4d54";
                        } else if (resultTitleTextWithoutSpaces == "Dark_Grey") {
                            sLiningColor = "#282024";
                        } else if (resultTitleTextWithoutSpaces == "Light_Blue") {
                            sLiningColor = "#40546b";
                        } else if (resultTitleTextWithoutSpaces == "Pink") {
                            sLiningColor = "#c72b52";
                        }
                        sLiningColor = getLiningColor(resultTitleTextWithoutSpaces);
                        //console.log(sLiningColor, resultTitleTextWithoutSpaces);
                        //console.log("update_lining_color", resultTitleTextWithoutSpaces);

                        update_lining_color();
                    }
                }
                //console.log(sSleeve_button);
                update_Lapel_width(
                    sLapelstyle,
                    sLapelwidth,
                    sLapel_buttonhole,
                    sAMF,
                    sLapel_button_hole_Position
                );
                update_Chest_Pocket(sChest_Pocket);
                update_Side_Pocket(side_pocket_value);
                update_Ticket_pockets(side_pocket_value);
                update_Lining(sLining);
                update_Sleeve_Button(sSleeve_button, sChest_Pocket, side_pocket_value);
                update_Shoulders(sShoulders);
                update_Vent(sVent, sAMF, sShoulders);
                update_Cuffed_sleeve(Cuffed_sleeve_value);
            }
        }
        $("body").removeClass("line-loading-3d-preview");
        obj.classList.contains("inactive_button") ? obj.classList.remove("inactive_button") : '';
    }, 400);
}

$(document).on(
    "click",
    ".cm-modifier-drawer[drawer-type='one'] .drawer1_apply, .cm-modifier-drawer .drawer2_apply, .cm-toggle-ele .cm-toggle-item,.btm_tab .cm-toggle-item,.btn-customize.next_button",
    function (event) {
        
        var currObj = this;

        // Added by softpulse
        if ($(currObj).parents(".isSelected").find(".is-selected").hasClass("cm-drawer-other-option-btn")) {
            $("body").removeClass("line-loading-3d-preview");
            currObj.classList.contains("inactive_button") ? currObj.classList.remove("inactive_button") : '';
            return;
        }
        if (event.isTrigger) {
            console.log("btn clicked ::: 1");
            modelvales(currObj);
            /*setTimeout(() => {
              console.log(123456);
              $(this).hasClass("inactive_button") ? $(this).removeClass("inactive_button") : '';
            }, 500);*/
        }
    }
);

/*$(document).on(
  "click",
  ".cm-modifier-drawer[drawer-type='one'] .cm-drawer-list .cm-drawer-container",
  function () {
    var curr_val = $(this).find("strong").text();
    //console.log("option select", curr_val);
    $(".cm-progress-container.isSelected").find(".active-option").find(".cm-modifier-result-title").text(curr_val);
    modelvales();
  }
);*/

// Get all the <fabric-list> tags within the parent <div>
// const fabricLists = document.querySelectorAll('.cm-card-list');

// fabricLists.forEach(fabricList => {
//   fabricList.addEventListener('click', function() {
//     console.log('Clicked on fabric-list tag', allfabrics[15]);
//     sCurruntFabric && updateMaterialFabric(allfabrics[15]);
//   });
// })

const fabricLists = document.querySelectorAll(".cm-card-list fabric-list");

if (fabricLists.length > 0) {
    const firstFabricList = fabricLists[0];
    const contentWrapper = firstFabricList.querySelector(
        ".cm-card-content-wrapper"
    );

    if (contentWrapper) {
        const fabricId = contentWrapper.getAttribute("data-fabricid");
        defaultfabriccode = fabricId;
        console.log("First fabric ID:", fabricId);
    } else {
        //console.log("No content wrapper found within the first fabric-list tag.");
    }
} else {
    //console.log("No fabric-list tags found.");
}
//console.log(fabricLists);
fabricLists.forEach((fabricList) => {
    fabricList.addEventListener("click", function () {
        //console.log("clicked on fabric");
        const contentWrapper = this.querySelector(".cm-card-content-wrapper");
        if (contentWrapper) {
            const fabricId = contentWrapper.getAttribute("data-fabricid");
            //console.log("allfabrics:", allfabrics);
            //console.log("Clicked on fabric-list tag with data-fabricid:", fabricId);
            const fid = allfabrics?.filter((fabric) => fabric.id === fabricId);
            //console.log("fid", fid);
            sCurruntFabric = fid[0];
            if (
                dataPageValue == "custom-made-trouser" ||
                trouserdiv.classList.contains("isSelected") ||
                trouseractive
            ) {
                fid[0] && updateMaterialFabricTrouser(fid[0]);
            } else if (
                dataPageValue == "custom-made-waistcoat" ||
                waistecoatdiv.classList.contains("isSelected") ||
                waistcoatactive
            ) {
                fid[0] && updateMaterialFabricWaistcoat(fid[0]);
            } else {
                console.log(fabricId);
                fid[0] && updateMaterialFabric(fid[0]);
            }
        } else {
            console.log(
                "No content wrapper found within the clicked fabric-list tag."
            );
        }
    });
});

function getLiningColor(color_code) {
    switch (color_code) {
        case "White":
            return "#C6C3BC";
            break;
        case "Black":
            return "#111111";
            break;
        case "Dark_Navy":
            return "#112139";
            break;
        case "Navy":
            return "#1D1F34";
            break;
        case "Mid_Navy":
            return "#1A2F4C";
            break;
        case "Dark_Grey":
            return "#4D4D4D";
            break;
        case "Light_Grey":
            return "#898989";
            break;
        case "Brown":
            return "#2e241e";
            break;
        case "Light_Blue":
            return "#9AB5C0";
            break;
        case "Light_Brown":
            return "#685037";
            break;
        case "Dark_Brown":
            return "#52402E";
            break;
        case "Beige":
            return "#AB947A";
            break;
        case "Khaki_green":
            return "#453b22";
            break;
        case "Pink":
            return "#9c5a70";
            break;
        case "Burgundy":
            return "#5E1A27";
            break;
        case "Red":
            return "#5A0206";
            break;
        case "Orange":
            return "#A8513C";
            break;
        case "Purple":
            return "#7e4eb5";
            break;
        default:
            return "#FFFFFF";
            break;
    }
}
